// src/components/property-reviews-list.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  fragment SpannableTextContentsFragment on EGDSSpannableText {\n    text\n    contents {\n      __typename\n      ... on EGDSPlainText {\n        text\n      }\n      ... on EGDSStandardLink {\n        action {\n          target\n          resource {\n            __typename\n            ... on HttpURI {\n              relativePath\n              value\n            }\n          }\n        }\n        text\n        size\n        icon {\n          description\n          id\n          size\n          theme\n        }\n        iconPosition\n      }\n      ... on EGDSInlineLink {\n        action {\n          target\n          resource {\n            __typename\n            ... on HttpURI {\n              relativePath\n              value\n            }\n          }\n        }\n        text\n        size\n      }\n    }\n    egdsElementId\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  fragment InputFieldParts on EGDSInputField {\n    value\n    label\n    placeholder\n    validations {\n      errorMessage\n      __typename\n      ... on EGDSMaxLengthInputValidation {\n        maxLength\n      }\n      ... on EGDSMinLengthInputValidation {\n        minLength\n      }\n      ... on EGDSRegexInputValidation {\n        pattern\n      }\n    }\n  }\n\n  fragment PageParts on DirectFeedbackFormPage {\n    __typename\n    title\n    elements {\n      __typename\n      ... on EGDSElement {\n        egdsElementId\n      }\n      ... on DirectFeedbackInputField {\n        ...InputFieldParts\n      }\n      ... on DirectFeedbackTextArea {\n        ...InputFieldParts\n      }\n      ... on DirectFeedbackMultiSelectGroup {\n        __typename\n        groupName\n        required\n        errorMessage\n        options {\n          label {\n            text\n          }\n          name\n        }\n      }\n      ... on EGDSPlainText {\n        text\n      }\n      ... on EGDSHeading {\n        text\n        headingType\n      }\n      ...SpannableTextContentsFragment\n    }\n    submitButton {\n      primary\n      egdsElementId\n    }\n    displayCondition {\n      fieldId\n      expectedValue\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  fragment ContentDirectFeedbackPromptFragment on DirectFeedbackPrompt {\n    title\n    pages {\n      ...PageParts\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  mutation ContentDirectFeedbackSubmit($context: ContextInput!, $id: ID!, $feedback: DirectFeedbackValuesInput!) {\n    directFeedbackSubmit(context: $context, id: $id, feedback: $feedback) {\n      errors {\n        fieldId\n        error\n      }\n    }\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  query ContentDirectFeedbackPromptQuery($context: ContextInput!, $id: ID!) {\n    directFeedbackPromptById(context: $context, id: $id) {\n      callToAction {\n        egdsElementId\n        icon {\n          id\n          size\n        }\n        primary\n      }\n      ...ContentDirectFeedbackPromptFragment\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  fragment EmptyStateFragment on UIEmptyState {\n    heading\n    body\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  fragment MessagingCardFragment on UIMessagingCard {\n    graphic {\n      __typename\n      ... on Icon {\n        id\n        description\n      }\n    }\n    primary\n    secondaries\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  fragment NoResultsMessageFragment on PropertyReviews {\n    noResultsMessage {\n      __typename\n      ...MessagingCardFragment\n      ...EmptyStateFragment\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n  fragment ReviewChildFragment on ManagementResponse {\n    id\n    header {\n      text\n    }\n    response\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n  fragment FeedbackIndicatorFragment on PropertyReview {\n    reviewInteractionSections {\n      primaryDisplayString\n      accessibilityLabel\n      reviewInteractionType\n      feedbackAnalytics {\n        linkName\n        referrerId\n      }\n    }\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n  mutation UpvotePropertyReviewWithAccessibility($context: ContextInput!, $reviewId: String!, $index: Int!) {\n    upvotePropertyReviewWithAccessibility(context: $context, reviewId: $reviewId, index: $index) {\n      primaryDisplayString\n      accessibilityLabel\n    }\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _taggedTemplateLiteral([
        "\n  fragment PhotosFragment on PropertyReview {\n    id\n    photoSection {\n      imageClickAnalytics {\n        referrerId\n        linkName\n      }\n      exitAnalytics {\n        referrerId\n        linkName\n      }\n      navClickAnalytics {\n        referrerId\n        linkName\n      }\n    }\n    photos {\n      description\n      url\n    }\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _taggedTemplateLiteral([
        "\n  fragment AuthorFragment on PropertyReview {\n    reviewAuthorAttribution {\n      text\n    }\n  }\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _taggedTemplateLiteral([
        "\n  fragment PropertyReviewFooterSectionFragment on PropertyReviewFooterSection {\n    messages {\n      seoStructuredData {\n        itemscope\n        itemprop\n        itemtype\n        content\n      }\n      text {\n        ... on EGDSPlainText {\n          text\n        }\n        ... on EGDSGraphicText {\n          text\n          graphic {\n            ... on Mark {\n              description\n              id\n              size\n              url {\n                ... on HttpURI {\n                  relativePath\n                  value\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = _taggedTemplateLiteral([
        "\n  fragment PropertyReviewRegionFragment on PropertyReview {\n    reviewRegion {\n      id\n    }\n  }\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = _taggedTemplateLiteral([
        "\n  fragment PropertyReviewSourceFragment on PropertyReview {\n    propertyReviewSource {\n      accessibilityLabel\n      graphic {\n        description\n        id\n        size\n        token\n        url {\n          value\n        }\n      }\n      text {\n        value\n      }\n    }\n  }\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = _taggedTemplateLiteral([
        "\n  fragment ReviewThemeFragment on ReviewThemes {\n    icon {\n      id\n    }\n    label\n  }\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = _taggedTemplateLiteral([
        "\n  fragment ReviewTranslationInfoFragment on PropertyReview {\n    translationInfo {\n      loadingTranslationText\n      targetLocale\n      translatedBy {\n        description\n      }\n      translationCallToActionLabel\n      seeOriginalText\n    }\n  }\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = _taggedTemplateLiteral([
        "\n  fragment TravelersFragment on PropertyReview {\n    travelers\n  }\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = _taggedTemplateLiteral([
        "\n  fragment ReviewParentFragment on PropertyReview {\n    id\n    superlative\n    locale\n    title\n    brandType\n    reviewScoreWithDescription {\n      label\n      value\n    }\n    text\n    seeMoreAnalytics {\n      linkName\n      referrerId\n    }\n    submissionTime {\n      longDateFormat\n    }\n    impressionAnalytics {\n      event\n      referrerId\n    }\n    themes {\n      ...ReviewThemeFragment\n    }\n    reviewFooter {\n      ...PropertyReviewFooterSectionFragment\n    }\n    ...FeedbackIndicatorFragment\n    ...AuthorFragment\n    ...PhotosFragment\n    ...TravelersFragment\n    ...ReviewTranslationInfoFragment\n    ...PropertyReviewSourceFragment\n    ...PropertyReviewRegionFragment\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = _taggedTemplateLiteral([
        "\n  query TranslateReviewQuery($context: ContextInput!, $propertyId: String!, $locale: Locale!, $reviewId: String!) {\n    propertyInfo(context: $context, propertyId: $propertyId) {\n      id\n      review(id: $reviewId, locale: $locale) {\n        translatedReviewId: id\n        translatedLocale: locale\n        translatedTitle: title\n        translatedText: text\n      }\n    }\n  }\n"
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = _taggedTemplateLiteral([
        "\n  fragment __PropertyReviewsListFragment on PropertyReviews {\n    summary {\n      paginateAction {\n        text\n        analytics {\n          referrerId\n          linkName\n        }\n      }\n    }\n    reviews {\n      contentDirectFeedbackPromptId\n      ...ReviewParentFragment\n      managementResponses {\n        ...ReviewChildFragment\n      }\n      reviewInteractionSections {\n        primaryDisplayString\n        reviewInteractionType\n      }\n    }\n    ...NoResultsMessageFragment\n  }\n  ",
        "\n  ",
        "\n  ",
        ",\n"
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = _taggedTemplateLiteral([
        "\n  query ReviewsQuery($context: ContextInput!, $propertyId: String!, $searchCriteria: PropertySearchCriteriaInput!) {\n    propertyInfo(propertyId: $propertyId, context: $context) {\n      id\n      reviewInfo(searchCriteria: $searchCriteria) {\n        ...__PropertyReviewsListFragment\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = _taggedTemplateLiteral([
        "\n  fragment LodgingEnrichedMessageFragment on LodgingEnrichedMessage {\n    __typename\n    subText\n    value\n    theme\n    state\n    accessibilityLabel\n    icon {\n      id\n      size\n    }\n    mark {\n      id\n    }\n    egdsMark {\n      url {\n        value\n      }\n    }\n  }\n"
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = _taggedTemplateLiteral([
        "\n  fragment RatingCountsFragment on PropertyReviewSummary {\n    ratingCounts {\n      count {\n        formatted\n      }\n      percent\n      rating\n      description\n      accessibilityLabel\n    }\n  }\n"
    ]);
    _templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}
function _templateObject25() {
    var data = _taggedTemplateLiteral([
        "\n  fragment ReviewSummaryDetailsFragment on PropertyReviewSummary {\n    reviewSummaryDetails {\n      label\n      formattedRatingOutOfMaxA11y {\n        value\n        accessibilityLabel\n      }\n    }\n  }\n"
    ]);
    _templateObject25 = function _templateObject25() {
        return data;
    };
    return data;
}
function _templateObject26() {
    var data = _taggedTemplateLiteral([
        "\n  fragment EGDSDialogToolbarFragment on EGDSDialogToolbar {\n    closeText\n    title\n  }\n"
    ]);
    _templateObject26 = function _templateObject26() {
        return data;
    };
    return data;
}
function _templateObject27() {
    var data = _taggedTemplateLiteral([
        "\n  fragment LodgingEGDSIconFragment on Icon {\n    description\n    id\n    size\n    theme\n  }\n"
    ]);
    _templateObject27 = function _templateObject27() {
        return data;
    };
    return data;
}
function _templateObject28() {
    var data = _taggedTemplateLiteral([
        "\n  fragment LodgingDialogTriggerMessageFragment on LodgingDialogTriggerMessage {\n    accessibilityLabel\n    value\n    icon {\n      ...LodgingEGDSIconFragment\n    }\n    clientSideAnalytics {\n      linkName\n      referrerId\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject28 = function _templateObject28() {
        return data;
    };
    return data;
}
function _templateObject29() {
    var data = _taggedTemplateLiteral([
        "\n  fragment PropertyFilteredReviewsDialogFragment on PropertyFilteredReviewsDialog {\n    trigger {\n      ...LodgingDialogTriggerMessageFragment\n    }\n    ratingPercentage {\n      closeAnalytics {\n        referrerId\n        linkName\n      }\n      toolbar {\n        ...EGDSDialogToolbarFragment\n      }\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject29 = function _templateObject29() {
        return data;
    };
    return data;
}
function _templateObject30() {
    var data = _taggedTemplateLiteral([
        "\n  fragment ReviewDisclaimerFragment on PropertyReviewSummary {\n    reviewDisclaimer\n    reviewDisclaimerLabel\n    reviewDisclaimerAnalytics {\n      referrerId\n      linkName\n    }\n    reviewDisclaimerUrl {\n      value\n      accessibilityLabel\n      link {\n        url\n      }\n    }\n    reviewDisclaimerAccessibilityLabel\n  }\n"
    ]);
    _templateObject30 = function _templateObject30() {
        return data;
    };
    return data;
}
function _templateObject31() {
    var data = _taggedTemplateLiteral([
        "\n  fragment PropertyReviewsBreakdownFragment on PropertyReviewSummary {\n    averageOverallRating {\n      formatted\n    }\n    superlative\n    propertyReviewCountDetails {\n      shortDescription\n    }\n    reviewDisclaimer\n    reviewDisclaimerLabel\n    ...ReviewDisclaimerFragment\n    totalCount {\n      raw\n    }\n    ...ReviewSummaryDetailsFragment\n    ...RatingCountsFragment\n    seeAllAction {\n      ...PropertyFilteredReviewsDialogFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject31 = function _templateObject31() {
        return data;
    };
    return data;
}
function _templateObject32() {
    var data = _taggedTemplateLiteral([
        "\n  fragment __PropertyReviewSummaryFragment on PropertyReviewSummary {\n    accessibilityLabel\n    overallScoreWithDescriptionA11y {\n      ...LodgingEnrichedMessageFragment\n    }\n    propertyReviewCountDetails {\n      fullDescription\n    }\n    ...ReviewDisclaimerFragment\n    reviewSummaryDetails {\n      label\n      ratingPercentage\n      formattedRatingOutOfMax\n    }\n    totalCount {\n      raw\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject32 = function _templateObject32() {
        return data;
    };
    return data;
}
function _templateObject33() {
    var data = _taggedTemplateLiteral([
        "\n  query PropertyReviewSummaries($context: ContextInput!, $propertyIds: [String!]!) {\n    propertyReviewSummaries(context: $context, propertyIds: $propertyIds) {\n      ...__PropertyReviewSummaryFragment\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject33 = function _templateObject33() {
        return data;
    };
    return data;
}
function _templateObject34() {
    var data = _taggedTemplateLiteral([
        "\n  query PropertyReviewAggregates($propertyIds: [String!]!, $context: ContextInput!) {\n    propertyReviewAggregates(propertyIds: $propertyIds, context: $context) {\n      propertySentiment {\n        text\n        subtext\n      }\n    }\n  }\n"
    ]);
    _templateObject34 = function _templateObject34() {
        return data;
    };
    return data;
}
function _templateObject35() {
    var data = _taggedTemplateLiteral([
        "\n  query PropertyReviewSummariesLine($context: ContextInput!, $propertyIds: [String!]!) {\n    propertyReviewSummaries(context: $context, propertyIds: $propertyIds) {\n      overallScoreWithDescription\n      propertyReviewCountDetails {\n        fullDescription\n      }\n      reviewDisclaimer\n      reviewDisclaimerAccessibilityLabel\n      totalCount {\n        raw\n      }\n    }\n  }\n"
    ]);
    _templateObject35 = function _templateObject35() {
        return data;
    };
    return data;
}
function _templateObject36() {
    var data = _taggedTemplateLiteral([
        "\n  fragment SearchTextFragment on SortAndFilterViewModel {\n    sortAndFilter {\n      name\n      label\n      graphic {\n        ... on Icon {\n          description\n          id\n          token\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject36 = function _templateObject36() {
        return data;
    };
    return data;
}
function _templateObject37() {
    var data = _taggedTemplateLiteral([
        "\n  fragment SortTypeFragment on SortAndFilterViewModel {\n    sortAndFilter {\n      name\n      label\n      clickAnalytics {\n        linkName\n        referrerId\n      }\n      options {\n        label\n        isSelected\n        optionValue\n        description\n        clickAnalytics {\n          linkName\n          referrerId\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject37 = function _templateObject37() {
        return data;
    };
    return data;
}
function _templateObject38() {
    var data = _taggedTemplateLiteral([
        "\n  fragment TravelerTypeFragment on SortAndFilterViewModel {\n    sortAndFilter {\n      name\n      label\n      options {\n        label\n        isSelected\n        optionValue\n        description\n        clickAnalytics {\n          linkName\n          referrerId\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject38 = function _templateObject38() {
        return data;
    };
    return data;
}
function _templateObject39() {
    var data = _taggedTemplateLiteral([
        "\n  query PropertyFilteredReviewsQuery($context: ContextInput!, $propertyId: String!, $searchCriteria: PropertySearchCriteriaInput!) {\n    propertyReviewSummaries(context: $context, propertyIds: [$propertyId], searchCriteria: $searchCriteria) {\n      ...__PropertyReviewSummaryFragment\n    }\n    propertyInfo(context: $context, propertyId: $propertyId) {\n      id\n      reviewInfo(searchCriteria: $searchCriteria) {\n        ...__PropertyReviewsListFragment\n        sortAndFilter {\n          ...TravelerTypeFragment\n          ...SortTypeFragment\n          ...SearchTextFragment\n        }\n      }\n    }\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject39 = function _templateObject39() {
        return data;
    };
    return data;
}
function _templateObject40() {
    var data = _taggedTemplateLiteral([
        "\n  query PropertyReviewsBreakdownQuery($context: ContextInput!, $propertyIds: [String!]!) {\n    propertyReviewSummaries(context: $context, propertyIds: $propertyIds) {\n      ...PropertyReviewsBreakdownFragment\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject40 = function _templateObject40() {
        return data;
    };
    return data;
}
function _templateObject41() {
    var data = _taggedTemplateLiteral([
        "\n  query PropertyReviewsQuery($context: ContextInput!, $propertyId: String!, $searchCriteria: PropertySearchCriteriaInput!) {\n    propertyInfo(context: $context, propertyId: $propertyId) {\n      id\n      reviewInfo(searchCriteria: $searchCriteria) {\n        summary {\n          seeAllReviewsCallToActionLabel\n          accessibilityLabel\n          ...PropertyReviewsBreakdownFragment\n        }\n        ...__PropertyReviewsListFragment\n      }\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject41 = function _templateObject41() {
        return data;
    };
    return data;
}
function _templateObject42() {
    var data = _taggedTemplateLiteral([
        "\n  query PropertyRoomScoresQuery($propertyIds: [String!]!, $context: ContextInput!, $withTags: Boolean!) {\n    propertyReviewAggregates(propertyIds: $propertyIds, context: $context) {\n      propertySummaries {\n        propertyId\n        roomsScore {\n          scoreLabel\n          id\n          roomRatingListTitle @include(if: $withTags)\n          tags @include(if: $withTags) {\n            label\n          }\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject42 = function _templateObject42() {
        return data;
    };
    return data;
}
import React20 from "react";
import { gql as gql20, useQuery as useQuery2 } from "@apollo/client";
import { useBexApi as useBexApi5 } from "@shared-ui/bex-api-context";
// src/utils/merge-search-criteria.ts
var mergeFilters = function(currentFilterList, newFilterList) {
    if (!currentFilterList || !newFilterList) return currentFilterList;
    return _toConsumableArray(newFilterList).concat(_toConsumableArray(currentFilterList.filter(function(param) {
        var oldId = param.id;
        return !newFilterList.some(function(filter) {
            return oldId === (filter === null || filter === void 0 ? void 0 : filter.id);
        });
    })));
};
var mergeSearchCriteria = function(currentSearchCriteria, newSearchCriteria) {
    var _currentSearchCriteria_secondary, _newSearchCriteria_secondary, _currentSearchCriteria_secondary1, _newSearchCriteria_secondary1, _currentSearchCriteria_secondary2, _newSearchCriteria_secondary2, _currentSearchCriteria_secondary3, _newSearchCriteria_secondary3, _currentSearchCriteria_secondary4, _newSearchCriteria_secondary4;
    if (!currentSearchCriteria || !newSearchCriteria) return currentSearchCriteria;
    return _objectSpreadProps(_objectSpread({}, currentSearchCriteria, newSearchCriteria), {
        secondary: {
            booleans: mergeFilters((_currentSearchCriteria_secondary = currentSearchCriteria.secondary) === null || _currentSearchCriteria_secondary === void 0 ? void 0 : _currentSearchCriteria_secondary.booleans, (_newSearchCriteria_secondary = newSearchCriteria.secondary) === null || _newSearchCriteria_secondary === void 0 ? void 0 : _newSearchCriteria_secondary.booleans),
            counts: mergeFilters((_currentSearchCriteria_secondary1 = currentSearchCriteria.secondary) === null || _currentSearchCriteria_secondary1 === void 0 ? void 0 : _currentSearchCriteria_secondary1.counts, (_newSearchCriteria_secondary1 = newSearchCriteria.secondary) === null || _newSearchCriteria_secondary1 === void 0 ? void 0 : _newSearchCriteria_secondary1.counts),
            dates: mergeFilters((_currentSearchCriteria_secondary2 = currentSearchCriteria.secondary) === null || _currentSearchCriteria_secondary2 === void 0 ? void 0 : _currentSearchCriteria_secondary2.dates, (_newSearchCriteria_secondary2 = newSearchCriteria.secondary) === null || _newSearchCriteria_secondary2 === void 0 ? void 0 : _newSearchCriteria_secondary2.dates),
            ranges: mergeFilters((_currentSearchCriteria_secondary3 = currentSearchCriteria.secondary) === null || _currentSearchCriteria_secondary3 === void 0 ? void 0 : _currentSearchCriteria_secondary3.ranges, (_newSearchCriteria_secondary3 = newSearchCriteria.secondary) === null || _newSearchCriteria_secondary3 === void 0 ? void 0 : _newSearchCriteria_secondary3.ranges),
            selections: mergeFilters((_currentSearchCriteria_secondary4 = currentSearchCriteria.secondary) === null || _currentSearchCriteria_secondary4 === void 0 ? void 0 : _currentSearchCriteria_secondary4.selections, (_newSearchCriteria_secondary4 = newSearchCriteria.secondary) === null || _newSearchCriteria_secondary4 === void 0 ? void 0 : _newSearchCriteria_secondary4.selections)
        }
    });
};
var merge_search_criteria_default = mergeSearchCriteria;
// src/utils/build-fetch-more-reviews.ts
var buildFetchMoreReviews = function(fetchMore, currentVariables) {
    return function(param) {
        var updateQuery = param.updateQuery, newVariables = param.variables;
        fetchMore({
            updateQuery: updateQuery,
            variables: _objectSpreadProps(_objectSpread({}, currentVariables, newVariables), {
                searchCriteria: merge_search_criteria_default(currentVariables.searchCriteria, newVariables.searchCriteria)
            })
        });
    };
};
// src/components/__private/__fragments/property-reviews-list.tsx
import React19 from "react";
import { useApolloClient } from "@apollo/client";
import { EgClickstreamImpressionTracker, useClickTracker as useClickTracker8 } from "@shared-ui/clickstream-analytics-context";
import { useExperiment } from "@shared-ui/experiment-context";
import { UitkSecondaryButton } from "uitk-react-button";
import { UitkCard as UitkCard2, UitkCardContentSection } from "uitk-react-cards";
import { UitkSpacing as UitkSpacing13 } from "uitk-react-spacing";
// src/utils/eg-clickstream-helpers.tsx
var IMPRESSION = "Impression";
var INTERACTION = "Interaction";
var buildInteractionEvent = function(eventName, eventType, eventVersion) {
    return {
        event: {
            event_name: eventName,
            event_type: eventType,
            event_version: eventVersion
        }
    };
};
var buildImpressionEvent = function(eventName, eventType, eventVersion) {
    var action_reason = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "", reviewsCount = arguments.length > 4 ? arguments[4] : void 0;
    return {
        event: {
            event_name: eventName,
            event_type: eventType,
            event_version: eventVersion,
            action_reason: action_reason
        },
        product_list: [
            {
                guest_rating_count: reviewsCount
            }
        ]
    };
};
var reviewSearchInitiatedEvent = function() {
    return buildInteractionEvent("reviews_search.initiated" /* INITIATE */ , INTERACTION, "1.0.0" /* ONE_ZERO_ZERO */ );
};
var reviewSearchSubmittedEvent = function() {
    return buildInteractionEvent("reviews_search.submitted" /* SUBMIT */ , INTERACTION, "1.0.0" /* ONE_ZERO_ZERO */ );
};
var reviewsViewedEvent = function(reviews, actionReason) {
    return buildImpressionEvent("reviews.viewed" /* VIEWED */ , IMPRESSION, "1.0.0" /* ONE_ZERO_ZERO */ , actionReason, reviews.length);
};
// src/components/__private/__fragments/content-direct-feedback/content-direct-feedback-call-to-action.tsx
import React4, { useState as useState3 } from "react";
import { gql as gql4, useQuery } from "@apollo/client";
import { useBexApi as useBexApi2 } from "@shared-ui/bex-api-context";
import { useClickTracker as useClickTracker3 } from "@shared-ui/clickstream-analytics-context";
import { useDialog } from "@shared-ui/dialog-context";
import { UitkIcon as UitkIcon2, UitkIconSize as UitkIconSize2 } from "uitk-react-icons";
import { UitkLink as UitkLink2 } from "uitk-react-link";
import { UitkSpacing as UitkSpacing3 } from "uitk-react-spacing";
import { UitkText as UitkText3 } from "uitk-react-text";
import { UitkToast } from "uitk-react-toast";
// src/components/__private/__fragments/content-direct-feedback/analytics-tracking.ts
var REPORT_REVIEW_DIALOG_TRACKER = {
    rfrr: "HOT.HIS.REVIEW.Report.FlagOpenDialog",
    link: "Report Review Dialog"
};
var REPORT_REVIEW_PARTNER_FORM = {
    rfrr: "HOT.HIS.REVIEW.Report.OpenPartnerDisputeForm",
    link: "Report Review Partner Dispute Form"
};
var REPORT_REVIEW_SUBMIT_FORM = {
    rfrr: "HOT.HIS.REVIEW.Report.Submit",
    link: "Report Review Partner Submit Form"
};
var reportReviewOptionsTracking = function(option) {
    return {
        rfrr: "HOT.HIS.REVIEW.Report.".concat(option),
        // I think using the option instead of the mapping would be more readable but this is the existing behavior
        link: "Review report reason is ".concat(option)
    };
};
// src/components/__private/__fragments/content-direct-feedback/content-direct-feedback-prompt.tsx
import React3, { useState as useState2 } from "react";
import { gql as gql3, useMutation } from "@apollo/client";
import { useBexApi } from "@shared-ui/bex-api-context";
import { useClickTracker as useClickTracker2 } from "@shared-ui/clickstream-analytics-context";
import { useLocalization } from "@shared-ui/localization-context";
import { UitkDialogContent } from "uitk-react-dialog";
import { UitkSheet } from "uitk-react-sheet";
import { UitkToolbar } from "uitk-react-toolbar";
// src/components/__private/__fragments/content-direct-feedback/content-direct-feedback-prompt-page.tsx
import React2, { useState } from "react";
import { gql as gql2 } from "@apollo/client";
import { UitkButtonSize, UitkPrimaryButton } from "uitk-react-button";
import { UitkCheckbox } from "uitk-react-checkbox";
import { UitkSpacing as UitkSpacing2 } from "uitk-react-spacing";
import { UitkHeading, UitkText as UitkText2 } from "uitk-react-text";
// src/components/__private/__fragments/content-direct-feedback/content-direct-feedback-prompt-spannable-text.tsx
import React from "react";
import { gql } from "@apollo/client";
import { useClickTracker } from "@shared-ui/clickstream-analytics-context";
import { UitkIcon, UitkIconSize } from "uitk-react-icons";
import { UitkLink } from "uitk-react-link";
import { UitkSpacing } from "uitk-react-spacing";
import { UitkText } from "uitk-react-text";
var fragment = gql(_templateObject());
var SpannableTextContents = function(param) {
    var content = param.content;
    var track = useClickTracker();
    var trackPartnerForm = function() {
        return track(REPORT_REVIEW_PARTNER_FORM.rfrr, REPORT_REVIEW_PARTNER_FORM.link);
    };
    switch(content.__typename){
        case "EGDSPlainText":
            return /* @__PURE__ */ React.createElement(React.Fragment, null, content.text);
        case "EGDSInlineLink":
            {
                var resourceType = content.action.resource.__typename;
                return resourceType === "HttpURI" ? /* @__PURE__ */ React.createElement(UitkLink, {
                    inline: true,
                    size: content.size.toLowerCase()
                }, /* @__PURE__ */ React.createElement("a", {
                    target: "_blank",
                    href: content.action.resource.value,
                    onClick: trackPartnerForm,
                    rel: "noreferrer"
                }, content.text)) : null;
            }
        case "EGDSStandardLink":
            {
                var _content_icon, _content_icon1, _content_icon2, _content_icon3;
                var resourceType1 = content.action.resource.__typename;
                return resourceType1 === "HttpURI" ? /* @__PURE__ */ React.createElement(UitkLink, {
                    inline: true,
                    size: content.size.toLowerCase()
                }, /* @__PURE__ */ React.createElement("a", {
                    target: "_blank",
                    href: content.action.resource.value,
                    onClick: trackPartnerForm,
                    rel: "noreferrer"
                }, content.text, /* @__PURE__ */ React.createElement(UitkSpacing, {
                    margin: {
                        blockend: "half"
                    }
                }, /* @__PURE__ */ React.createElement(UitkIcon, {
                    id: ((_content_icon = content.icon) === null || _content_icon === void 0 ? void 0 : _content_icon.id) || "",
                    name: ((_content_icon1 = content.icon) === null || _content_icon1 === void 0 ? void 0 : _content_icon1.id) || "",
                    size: ((_content_icon2 = content.icon) === null || _content_icon2 === void 0 ? void 0 : _content_icon2.size) && UitkIconSize[content.icon.size],
                    title: (_content_icon3 = content.icon) === null || _content_icon3 === void 0 ? void 0 : _content_icon3.description
                })))) : null;
            }
        default:
            return null;
    }
};
var SpannableText = function(param) {
    var data = param.data;
    return /* @__PURE__ */ React.createElement(UitkText, {
        size: 300,
        spacing: "two"
    }, data.contents.map(function(content, index) {
        return /* @__PURE__ */ React.createElement(SpannableTextContents, {
            key: "".concat(content.__typename, "-").concat(index),
            content: content
        });
    }));
};
SpannableText.displayName = "SpannableText";
SpannableText.fragment = fragment;
// src/components/__private/__fragments/content-direct-feedback/content-direct-feedback-prompt-page.tsx
var fragment2 = gql2(_templateObject1(), SpannableText.fragment);
var ContentDirectFeedbackPromptPage = function(param) {
    var data = param.data, handleSubmit = param.handleSubmit, loading = param.loading, reportStateUpdatetoParent = param.reportStateUpdatetoParent;
    var _useState = _slicedToArray(useState({}), 2), checkboxSelectedMap = _useState[0], setCheckboxSelectedMap = _useState[1];
    var handleCheckboxChange = function(event) {
        var nextState = _objectSpreadProps(_objectSpread({}, checkboxSelectedMap), _defineProperty({}, event.currentTarget.value, event.currentTarget.checked));
        setCheckboxSelectedMap(nextState);
        reportStateUpdatetoParent(nextState);
    };
    var checkboxesElement = data.elements.find(function(el) {
        return el.__typename === "DirectFeedbackMultiSelectGroup";
    });
    var isAnyCheckboxSelectedRequired = !!(checkboxesElement === null || checkboxesElement === void 0 ? void 0 : checkboxesElement.required);
    var isAnyCheckboxSelected = Object.keys(checkboxSelectedMap).some(function(key) {
        return checkboxSelectedMap[key];
    });
    var isSubmitDisabled = loading || isAnyCheckboxSelectedRequired && !isAnyCheckboxSelected;
    return /* @__PURE__ */ React2.createElement(React2.Fragment, null, data.elements.map(function(element, index) {
        switch(element.__typename){
            case "EGDSPlainText":
                return /* @__PURE__ */ React2.createElement(UitkSpacing2, {
                    key: "".concat(element.__typename, "-").concat(index),
                    margin: {
                        blockstart: "six",
                        blockend: "two"
                    }
                }, /* @__PURE__ */ React2.createElement(UitkText2, {
                    size: 300,
                    spacing: "two"
                }, element.text));
            case "EGDSSpannableText":
                return /* @__PURE__ */ React2.createElement(UitkSpacing2, {
                    key: "".concat(element.__typename, "-").concat(index),
                    margin: {
                        blockstart: "six",
                        blockend: "two"
                    }
                }, /* @__PURE__ */ React2.createElement(SpannableText, {
                    data: element
                }));
            case "EGDSHeading":
                var _element_headingType;
                return /* @__PURE__ */ React2.createElement(UitkSpacing2, {
                    key: "".concat(element.__typename, "-").concat(index),
                    margin: {
                        blockstart: "three",
                        blockend: "two"
                    }
                }, /* @__PURE__ */ React2.createElement(UitkHeading, {
                    tag: (_element_headingType = element.headingType) === null || _element_headingType === void 0 ? void 0 : _element_headingType.toLowerCase(),
                    size: 5
                }, element.text));
            case "DirectFeedbackMultiSelectGroup":
                return /* @__PURE__ */ React2.createElement(React2.Fragment, {
                    key: "".concat(element.__typename, "-").concat(index)
                }, element.options.map(function(option, optionIndex) {
                    var text = option.label.text, optionValue = option.name;
                    return /* @__PURE__ */ React2.createElement(UitkCheckbox, {
                        id: "".concat(text, "-").concat(optionValue),
                        key: "".concat(option.__typename, "-").concat(optionIndex),
                        onChange: handleCheckboxChange,
                        value: optionValue || "",
                        checked: checkboxSelectedMap[optionValue || ""]
                    }, text);
                }));
            default:
                return null;
        }
    }), /* @__PURE__ */ React2.createElement(UitkSpacing2, {
        margin: {
            blockstart: "four"
        }
    }, /* @__PURE__ */ React2.createElement("div", null, /* @__PURE__ */ React2.createElement(UitkPrimaryButton, {
        disabled: isSubmitDisabled,
        onClick: handleSubmit,
        size: UitkButtonSize.SMALL
    }, data.submitButton.primary))));
};
ContentDirectFeedbackPromptPage.displayName = "ContentDirectFeedbackPromptPage";
ContentDirectFeedbackPromptPage.fragment = fragment2;
// src/components/__private/__fragments/content-direct-feedback/content-direct-feedback-prompt.tsx
var fragment3 = gql3(_templateObject2(), ContentDirectFeedbackPromptPage.fragment);
var mutation = gql3(_templateObject3());
var getMutationFeedback = function(feedbackContext, checkboxState) {
    var transformMapToMultiselect = function(map) {
        return {
            key: "report_category",
            value: Object.keys(map).filter(function(key) {
                return map[key];
            }).join(",")
        };
    };
    return {
        context: feedbackContext,
        formValues: [
            // TODO: dynamically build this array from prompt data
            transformMapToMultiselect(checkboxState)
        ]
    };
};
var ContentDirectFeedbackPrompt = function(param) {
    var closeReportDialog = param.closeReportDialog, data = param.data, feedbackContext = param.feedbackContext, handleShowToast = param.handleShowToast, hideReview = param.hideReview, inputs = param.inputs, triggerRef = param.triggerRef;
    var formatText = useLocalization().formatText;
    var _useMutation = _slicedToArray(useMutation(mutation), 2), fireCDFMutation = _useMutation[0], loading = _useMutation[1].loading;
    var context = useBexApi().context;
    var _useState2 = _slicedToArray(useState2({}), 2), childCheckboxSelectedMap = _useState2[0], setChildCheckboxSelectedMap = _useState2[1];
    var track = useClickTracker2();
    var validatedPromptTitle = data.title || "Report review";
    var validatedPromptIconLabel = formatText("close.dialog");
    var firstPage = data.pages[0];
    var handleChildStateUpdate = function(nextState) {
        setChildCheckboxSelectedMap(nextState);
    };
    var handleSubmit = function() {
        if (loading) {
            return;
        }
        var feedback = getMutationFeedback(feedbackContext, childCheckboxSelectedMap);
        fireCDFMutation({
            variables: {
                context: context,
                feedback: feedback,
                id: inputs === null || inputs === void 0 ? void 0 : inputs.id
            }
        });
        hideReview();
        var selectedOptions = Object.entries(childCheckboxSelectedMap).filter(function(param) {
            var _param = _slicedToArray(param, 2), _ = _param[0], value = _param[1];
            return value;
        });
        selectedOptions.forEach(function(selectedOption) {
            var _selectedOption = _slicedToArray(selectedOption, 2), key = _selectedOption[0], _ = _selectedOption[1];
            var _reportReviewOptionsTracking = reportReviewOptionsTracking(key), rfrr = _reportReviewOptionsTracking.rfrr, link = _reportReviewOptionsTracking.link;
            track(rfrr, link, true);
        });
        track(REPORT_REVIEW_SUBMIT_FORM.rfrr, REPORT_REVIEW_SUBMIT_FORM.link, true);
        closeReportDialog();
        handleShowToast();
    };
    return /* @__PURE__ */ React3.createElement(UitkSheet, {
        type: "centered",
        isVisible: true,
        triggerRef: triggerRef
    }, /* @__PURE__ */ React3.createElement(UitkToolbar, {
        toolbarTitle: validatedPromptTitle,
        navigationContent: {
            onClick: closeReportDialog,
            navIconLabel: validatedPromptIconLabel,
            navType: "close"
        }
    }), /* @__PURE__ */ React3.createElement(UitkDialogContent, null, /* @__PURE__ */ React3.createElement(ContentDirectFeedbackPromptPage, {
        data: firstPage,
        handleSubmit: handleSubmit,
        loading: loading,
        reportStateUpdatetoParent: handleChildStateUpdate
    })));
};
ContentDirectFeedbackPrompt.displayName = "ContentDirectFeedbackPrompt";
ContentDirectFeedbackPrompt.fragment = fragment3;
// src/components/__private/__fragments/content-direct-feedback/content-direct-feedback-call-to-action.tsx
var query = gql4(_templateObject4(), ContentDirectFeedbackPrompt.fragment);
var ContentDirectFeedbackCallToAction = function(props) {
    var _prompt_callToAction, _prompt_callToAction1;
    var dialogId = props.dialogId, id = props.inputs.id;
    var context = useBexApi2().context;
    var _useQuery = useQuery(query, {
        variables: {
            id: id,
            context: context
        }
    }), data = _useQuery.data, error = _useQuery.error, loading = _useQuery.loading;
    var _useState3 = _slicedToArray(useState3(false), 2), showToast = _useState3[0], setShowToast = _useState3[1];
    var _useDialog = _slicedToArray(useDialog("content-direct-feedback-dialog-".concat(dialogId), "pwaDialogNested"), 3), dialogActions = _useDialog[1], DialogComponent = _useDialog[2];
    var track = useClickTracker3();
    var triggerRef = React4.useRef(null);
    var prompt = data === null || data === void 0 ? void 0 : data.directFeedbackPromptById;
    if (error || loading || !prompt) {
        return null;
    }
    var openDialog = dialogActions.openDialog, closeDialog = dialogActions.closeDialog;
    var ctaText = (_prompt_callToAction = prompt.callToAction) === null || _prompt_callToAction === void 0 ? void 0 : _prompt_callToAction.primary;
    var ctaIcon = (_prompt_callToAction1 = prompt.callToAction) === null || _prompt_callToAction1 === void 0 ? void 0 : _prompt_callToAction1.icon;
    var lastPage = prompt === null || prompt === void 0 ? void 0 : prompt.pages[1];
    var toast = lastPage === null || lastPage === void 0 ? void 0 : lastPage.elements.find(function(el) {
        return el.__typename === "EGDSPlainText";
    });
    var handleCtaOnClick = function() {
        track(REPORT_REVIEW_DIALOG_TRACKER.rfrr, REPORT_REVIEW_DIALOG_TRACKER.link);
        openDialog();
        setShowToast(false);
    };
    return /* @__PURE__ */ React4.createElement(React4.Fragment, null, /* @__PURE__ */ React4.createElement(UitkLink2, {
        inline: true,
        onClick: handleCtaOnClick
    }, /* @__PURE__ */ React4.createElement("button", {
        type: "button",
        ref: triggerRef
    }, /* @__PURE__ */ React4.createElement(UitkIcon2, {
        name: (ctaIcon === null || ctaIcon === void 0 ? void 0 : ctaIcon.id) || "",
        key: ctaIcon === null || ctaIcon === void 0 ? void 0 : ctaIcon.id,
        size: (ctaIcon === null || ctaIcon === void 0 ? void 0 : ctaIcon.size) && UitkIconSize2[ctaIcon.size]
    }), /* @__PURE__ */ React4.createElement(UitkSpacing3, {
        padding: {
            inlinestart: "one"
        }
    }, /* @__PURE__ */ React4.createElement(UitkText3, {
        inline: true,
        size: 200
    }, ctaText)))), /* @__PURE__ */ React4.createElement(DialogComponent, null, /* @__PURE__ */ React4.createElement(ContentDirectFeedbackPrompt, _objectSpreadProps(_objectSpread({}, props), {
        closeReportDialog: closeDialog,
        data: prompt,
        handleShowToast: function() {
            return setShowToast(true);
        },
        triggerRef: triggerRef
    }))), toast && /* @__PURE__ */ React4.createElement(UitkToast, {
        show: showToast
    }, toast.text));
};
ContentDirectFeedbackCallToAction.displayName = "ContentDirectFeedbackCallToAction";
// src/components/__private/__fragments/no-results-message.tsx
import React7 from "react";
import { gql as gql7 } from "@apollo/client";
// src/components/__private/__fragments/empty-state.tsx
import React5 from "react";
import { gql as gql5 } from "@apollo/client";
import { UitkEmptyState } from "uitk-react-empty-state";
import { UitkSpacing as UitkSpacing4 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading2, UitkText as UitkText4 } from "uitk-react-text";
var fragment4 = gql5(_templateObject5());
var EmptyState = function(param) {
    var data = param.data;
    var heading = data.heading, body = data.body;
    return /* @__PURE__ */ React5.createElement(UitkEmptyState, null, /* @__PURE__ */ React5.createElement(UitkSpacing4, {
        margin: {
            blockstart: "six"
        }
    }, /* @__PURE__ */ React5.createElement(UitkHeading2, {
        size: 5,
        tag: "h3"
    }, heading)), /* @__PURE__ */ React5.createElement(UitkText4, {
        spacing: "two",
        size: 300
    }, body));
};
EmptyState.displayName = "EmptyState";
EmptyState.fragment = fragment4;
EmptyState.fragment.__typename = "UIEmptyState";
// src/components/__private/__fragments/messaging-card.tsx
import React6 from "react";
import { gql as gql6 } from "@apollo/client";
import { UitkCard } from "uitk-react-cards";
import { UitkIcon as UitkIcon3 } from "uitk-react-icons";
import { UitkLayoutFlex, UitkLayoutFlexItem } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing5 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading3, UitkText as UitkText5 } from "uitk-react-text";
var fragment5 = gql6(_templateObject6());
var MessagingCard = function(param) {
    var data = param.data;
    var graphic = data.graphic, primary = data.primary, secondaries = data.secondaries;
    var icon = (graphic === null || graphic === void 0 ? void 0 : graphic.__typename) === "Icon" && /* @__PURE__ */ React6.createElement(UitkIcon3, {
        name: graphic.id,
        id: graphic.id,
        description: graphic.description,
        spotlight: "info"
    });
    return /* @__PURE__ */ React6.createElement(UitkCard, {
        padded: true,
        border: true
    }, /* @__PURE__ */ React6.createElement(UitkLayoutFlex, {
        alignItems: "center",
        space: "two"
    }, /* @__PURE__ */ React6.createElement(UitkLayoutFlexItem, null, /* @__PURE__ */ React6.createElement("div", null, icon)), /* @__PURE__ */ React6.createElement(UitkSpacing5, {
        margin: {
            inlinestart: "two"
        }
    }, /* @__PURE__ */ React6.createElement(UitkLayoutFlexItem, null, /* @__PURE__ */ React6.createElement("div", null, /* @__PURE__ */ React6.createElement(React6.Fragment, null, primary && /* @__PURE__ */ React6.createElement(UitkHeading3, {
        tag: "h4"
    }, primary)), /* @__PURE__ */ React6.createElement(UitkText5, {
        size: 300
    }, secondaries === null || secondaries === void 0 ? void 0 : secondaries[0]))))));
};
MessagingCard.displayName = "MessagingCard";
MessagingCard.fragment = fragment5;
MessagingCard.fragment.__typename = "UIMessagingCard";
// src/components/__private/__fragments/no-results-message.tsx
var fragment6 = gql7(_templateObject7(), MessagingCard.fragment, EmptyState.fragment);
var NoResultsMessage = function(param) {
    var data = param.data;
    var noResultsMessage = data.noResultsMessage;
    if (!noResultsMessage) {
        return null;
    }
    var component;
    if (noResultsMessage.__typename === MessagingCard.fragment.__typename) {
        component = /* @__PURE__ */ React7.createElement(MessagingCard, {
            data: noResultsMessage
        });
    } else if (noResultsMessage.__typename === EmptyState.fragment.__typename) {
        component = /* @__PURE__ */ React7.createElement(EmptyState, {
            data: noResultsMessage
        });
    }
    return component;
};
NoResultsMessage.fragment = fragment6;
NoResultsMessage.displayName = "NoResultsMessage";
// src/components/__private/__fragments/property-reviews-list-fragment.ts
import { gql as gql19 } from "@apollo/client";
// src/components/__private/__fragments/review-child.tsx
import React8 from "react";
import { gql as gql8 } from "@apollo/client";
import { UitkSpacing as UitkSpacing6 } from "uitk-react-spacing";
import { UitkText as UitkText6 } from "uitk-react-text";
var fragment7 = gql8(_templateObject8());
var ReviewChild = function(param) {
    var data = param.data;
    var id = data.id, header = data.header, response = data.response;
    if (!id || !response) {
        return null;
    }
    return /* @__PURE__ */ React8.createElement(UitkSpacing6, {
        border: [
            "inlinestart"
        ],
        padding: {
            inlinestart: "three"
        },
        margin: {
            blockstart: "four"
        }
    }, /* @__PURE__ */ React8.createElement("article", {
        id: id
    }, /* @__PURE__ */ React8.createElement("section", null, (header === null || header === void 0 ? void 0 : header.text) && /* @__PURE__ */ React8.createElement(UitkText6, {
        weight: "bold",
        size: 200
    }, header.text)), /* @__PURE__ */ React8.createElement("section", null, /* @__PURE__ */ React8.createElement(UitkSpacing6, {
        padding: {
            block: "two"
        }
    }, /* @__PURE__ */ React8.createElement(UitkText6, {
        size: 200,
        theme: "default"
    }, response)))));
};
ReviewChild.displayName = "ReviewChild";
ReviewChild.fragment = fragment7;
var review_child_default = ReviewChild;
// src/components/__private/__fragments/review-parent.tsx
import React18 from "react";
import { gql as gql18, useLazyQuery } from "@apollo/client";
import { useBexApi as useBexApi4 } from "@shared-ui/bex-api-context";
import { IntersectionTracker, useClickTracker as useClickTracker7 } from "@shared-ui/clickstream-analytics-context";
import { UitkExpandoPeek } from "uitk-react-expando";
import { UitkLayoutFlex as UitkLayoutFlex4, UitkLayoutFlexItem as UitkLayoutFlexItem4 } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing12 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading6, UitkText as UitkText13 } from "uitk-react-text";
// src/components/__private/analytics.ts
var UPVOTE_TRACKER = {
    link: "upvote a review",
    rfrr: "HOT.HIS.REVIEW.THUMB_UP.UPVOTE"
};
var TRANSLATE_TRACKER = {
    link: "Google translated review",
    rfrr: "HOT.HIS.Reviews.GoogleTranslate"
};
var DISCLAIMER_DIALOG_TRACKER = {
    rfrr: "HOT.HIS.Reviews.DisclaimerDialog",
    link: "Review Disclaimer Dialog"
};
var SEE_ALL_REVIEWS_TRACKER = {
    rfrr: "HOT.HIS.Reviews.ClickSeeAllReviewsToOpenDialog",
    link: "See All Reviews"
};
// src/components/__private/__fragments/feedback-indicator.tsx
import React9, { useEffect } from "react";
import { gql as gql9, useMutation as useMutation2 } from "@apollo/client";
import { useBexApi as useBexApi3 } from "@shared-ui/bex-api-context";
import { useClickTracker as useClickTracker4 } from "@shared-ui/clickstream-analytics-context";
import { UitkIcon as UitkIcon4, UitkIconSize as UitkIconSize3 } from "uitk-react-icons";
import { UitkLink as UitkLink3 } from "uitk-react-link";
import { UitkSpacing as UitkSpacing7 } from "uitk-react-spacing";
import { UitkText as UitkText7 } from "uitk-react-text";
import { Level, liveAnnounce } from "uitk-react-utils";
var fragment8 = gql9(_templateObject9());
var MutationUpvotePropertyReviewWithAccessibility = gql9(_templateObject10());
var FeedbackIndicator = function(param) {
    var data = param.data, reviewId = param.reviewId, reviewIndex = param.reviewIndex, reviewsPage = param.reviewsPage;
    var _mutationStatus_data;
    var context = useBexApi3().context;
    var reviewInteractionSections = data.reviewInteractionSections;
    var _useMutation2 = _slicedToArray(useMutation2(MutationUpvotePropertyReviewWithAccessibility), 2), upvoteMutation = _useMutation2[0], mutationStatus = _useMutation2[1];
    var tracker = useClickTracker4();
    var mutationData = mutationStatus === null || mutationStatus === void 0 ? void 0 : (_mutationStatus_data = mutationStatus.data) === null || _mutationStatus_data === void 0 ? void 0 : _mutationStatus_data.upvotePropertyReviewWithAccessibility;
    useEffect(function() {
        if (mutationData === null || mutationData === void 0 ? void 0 : mutationData.accessibilityLabel) {
            var _mutationData_accessibilityLabel;
            liveAnnounce((_mutationData_accessibilityLabel = mutationData === null || mutationData === void 0 ? void 0 : mutationData.accessibilityLabel) !== null && _mutationData_accessibilityLabel !== void 0 ? _mutationData_accessibilityLabel : "", Level.POLITE);
        }
    }, [
        mutationData
    ]);
    if (!(reviewInteractionSections === null || reviewInteractionSections === void 0 ? void 0 : reviewInteractionSections.length)) {
        return null;
    }
    var feedbackIndicatorInteractionSection = reviewInteractionSections === null || reviewInteractionSections === void 0 ? void 0 : reviewInteractionSections.find(function(section) {
        return section.reviewInteractionType === "HELPFUL_REVIEW" /* HELPFUL_REVIEW */ ;
    });
    if (!feedbackIndicatorInteractionSection) {
        return null;
    }
    var primaryDisplayString = feedbackIndicatorInteractionSection.primaryDisplayString, accessibilityLabel = feedbackIndicatorInteractionSection.accessibilityLabel, feedbackAnalytics = feedbackIndicatorInteractionSection.feedbackAnalytics;
    var _mutationData_primaryDisplayString;
    var labelCount = (_mutationData_primaryDisplayString = mutationData === null || mutationData === void 0 ? void 0 : mutationData.primaryDisplayString) !== null && _mutationData_primaryDisplayString !== void 0 ? _mutationData_primaryDisplayString : primaryDisplayString;
    var _mutationData_accessibilityLabel;
    var label = (_mutationData_accessibilityLabel = mutationData === null || mutationData === void 0 ? void 0 : mutationData.accessibilityLabel) !== null && _mutationData_accessibilityLabel !== void 0 ? _mutationData_accessibilityLabel : accessibilityLabel;
    return /* @__PURE__ */ React9.createElement(UitkSpacing7, {
        padding: {
            inlineend: "one"
        }
    }, /* @__PURE__ */ React9.createElement("div", {
        "data-stid": "property-review-feedback-indicator"
    }, /* @__PURE__ */ React9.createElement(UitkLink3, {
        disabled: mutationStatus === null || mutationStatus === void 0 ? void 0 : mutationStatus.called,
        onClick: function() {
            if (feedbackAnalytics && reviewsPage === "ReviewsOverlay" /* REVIEWS_OVERLAY */ ) {
                tracker(feedbackAnalytics.referrerId, feedbackAnalytics.linkName);
            } else {
                tracker(UPVOTE_TRACKER.rfrr, UPVOTE_TRACKER.link);
            }
            upvoteMutation({
                variables: {
                    context: context,
                    reviewId: reviewId,
                    index: reviewIndex
                }
            });
        }
    }, /* @__PURE__ */ React9.createElement("button", {
        "aria-label": label !== null && label !== void 0 ? label : "",
        type: "button"
    }, /* @__PURE__ */ React9.createElement(UitkIcon4, {
        name: "thumb_up",
        size: UitkIconSize3.EXTRA_SMALL
    }), labelCount && /* @__PURE__ */ React9.createElement(LabelCount, {
        count: labelCount
    })))));
};
var LabelCount = function(param) {
    var count = param.count;
    return /* @__PURE__ */ React9.createElement(UitkSpacing7, {
        padding: {
            inlinestart: "one"
        }
    }, /* @__PURE__ */ React9.createElement(UitkText7, {
        inline: true,
        size: 200
    }, count));
};
FeedbackIndicator.displayName = "FeedbackIndicator";
FeedbackIndicator.fragment = fragment8;
var feedback_indicator_default = FeedbackIndicator;
// src/components/__private/__fragments/photos.tsx
import React10 from "react";
import { gql as gql10 } from "@apollo/client";
import { useClickTracker as useClickTracker5 } from "@shared-ui/clickstream-analytics-context";
import { useDialog as useDialog2 } from "@shared-ui/dialog-context";
import { UitkButton } from "uitk-react-button";
import { UitkFigure, UitkFigureAspectRatioType, UitkImage, UitkImageLink } from "uitk-react-images";
import { UitkLayoutGrid, UitkLayoutGridItem } from "uitk-react-layout-grid";
import { UitkMediaGalleryImageDialog, UitkMediaGalleryImageView } from "uitk-react-media-gallery";
import { UitkSpacing as UitkSpacing8 } from "uitk-react-spacing";
var __PhotosFragment = gql10(_templateObject11());
var Photos = function(param) {
    var data = param.data, reviewsPage = param.reviewsPage;
    var id = data.id, photos = data.photos, photoSection = data.photoSection;
    var _ref = photoSection || {}, imageClickAnalytics = _ref.imageClickAnalytics, exitAnalytics = _ref.exitAnalytics, navClickAnalytics = _ref.navClickAnalytics;
    var track = useClickTracker5();
    var triggerImageBtn = React10.useRef(null);
    var _React10_useState = _slicedToArray(React10.useState(0), 2), currentGalleryIndex = _React10_useState[0], setCurrentGalleryIndex = _React10_useState[1];
    var _useDialog2 = _slicedToArray(useDialog2("review-".concat(id, "-photo-gallery-dialog"), "pwaPhotosReviewsDialog"), 3), isDialogOpen = _useDialog2[0], dialogActions = _useDialog2[1], DialogComponent = _useDialog2[2];
    var handleImageClick = React10.useCallback(function(index) {
        if (imageClickAnalytics) {
            var linkName = imageClickAnalytics.linkName;
            var referrerId = imageClickAnalytics.referrerId;
            if (reviewsPage && referrerId && linkName) {
                referrerId = referrerId.replace("reviewsPage", reviewsPage);
                track(referrerId, linkName);
            }
        }
        triggerImageBtn.current = document.activeElement;
        setCurrentGalleryIndex(index);
        dialogActions.openDialog();
    }, [
        dialogActions,
        imageClickAnalytics,
        reviewsPage,
        track
    ]);
    var handleImageDialogClose = function() {
        var _triggerImageBtn_current;
        (_triggerImageBtn_current = triggerImageBtn.current) === null || _triggerImageBtn_current === void 0 ? void 0 : _triggerImageBtn_current.focus();
        dialogActions.closeDialog();
        if (exitAnalytics) {
            var linkName = exitAnalytics.linkName;
            var referrerId = exitAnalytics.referrerId;
            if (reviewsPage && referrerId && linkName) {
                referrerId = referrerId.replace("reviewsPage", reviewsPage);
                track(referrerId, linkName);
            }
        }
    };
    var navButtonAnalytics = reviewsPage && (navClickAnalytics === null || navClickAnalytics === void 0 ? void 0 : navClickAnalytics.referrerId) ? {
        id: navClickAnalytics.referrerId,
        description: navClickAnalytics.linkName,
        callback: function(referrerId, linkname) {
            return track(referrerId, linkname);
        }
    } : void 0;
    var galleryImages = React10.useMemo(function() {
        return photos === null || photos === void 0 ? void 0 : photos.map(function(photo) {
            return {
                src: photo.url,
                caption: photo.description
            };
        });
    }, [
        photos
    ]);
    if (!(photos === null || photos === void 0 ? void 0 : photos.length)) {
        return null;
    }
    var mediaGalleryImageViewProps = {
        currentIndex: currentGalleryIndex,
        onIndexChange: setCurrentGalleryIndex
    };
    return /* @__PURE__ */ React10.createElement(React10.Fragment, null, /* @__PURE__ */ React10.createElement(UitkSpacing8, {
        padding: {
            block: "two"
        }
    }, /* @__PURE__ */ React10.createElement(UitkLayoutGrid, {
        columns: 4,
        rows: 1
    }, photos.slice(0, 4).map(function(photo, index) {
        return /* @__PURE__ */ React10.createElement(UitkLayoutGridItem, {
            key: photo.url
        }, /* @__PURE__ */ React10.createElement(UitkFigure, {
            ratio: UitkFigureAspectRatioType.R4_3,
            className: "all-image-fit-cover"
        }, /* @__PURE__ */ React10.createElement(UitkImage, {
            src: photo.url,
            alt: photo.description
        }), /* @__PURE__ */ React10.createElement(UitkImageLink, null, /* @__PURE__ */ React10.createElement(UitkButton, {
            onClick: function() {
                return handleImageClick(index);
            },
            domRef: triggerImageBtn
        }))));
    }))), /* @__PURE__ */ React10.createElement(DialogComponent, null, /* @__PURE__ */ React10.createElement(UitkMediaGalleryImageDialog, {
        dialogShow: isDialogOpen,
        onDismiss: handleImageDialogClose,
        triggerRef: triggerImageBtn,
        strictFullscreen: true
    }, /* @__PURE__ */ React10.createElement(UitkMediaGalleryImageView, _objectSpreadProps(_objectSpread({}, mediaGalleryImageViewProps), {
        images: galleryImages,
        stretchToFill: false,
        galleryName: reviewsPage,
        analytics: navButtonAnalytics
    })))));
};
Photos.displayName = "Photos";
Photos.fragment = __PhotosFragment;
// src/components/__private/__fragments/property-review-author.tsx
import React11 from "react";
import { gql as gql11 } from "@apollo/client";
import { UitkHeading as UitkHeading4 } from "uitk-react-text";
var __AuthorFragment = gql11(_templateObject12());
var PropertyReviewAuthor = function(param) {
    var data = param.data;
    var _data_reviewAuthorAttribution;
    var authorAttributionText = (_data_reviewAuthorAttribution = data.reviewAuthorAttribution) === null || _data_reviewAuthorAttribution === void 0 ? void 0 : _data_reviewAuthorAttribution.text;
    if (!authorAttributionText) {
        return null;
    }
    return /* @__PURE__ */ React11.createElement(UitkHeading4, {
        size: 7,
        tag: "h4"
    }, authorAttributionText);
};
PropertyReviewAuthor.displayName = "PropertyReviewAuthor";
PropertyReviewAuthor.fragment = __AuthorFragment;
// src/components/__private/__fragments/property-review-footer-section.tsx
import React12 from "react";
import { gql as gql12 } from "@apollo/client";
import { UitkLayoutFlex as UitkLayoutFlex2, UitkLayoutFlexItem as UitkLayoutFlexItem2 } from "uitk-react-layout-flex";
import { UitkMarkFlag } from "uitk-react-mark";
import { UitkHeading as UitkHeading5, UitkText as UitkText8 } from "uitk-react-text";
var fragment9 = gql12(_templateObject13());
var PropertyReviewFooterSection = function(param) {
    var data = param.data;
    return /* @__PURE__ */ React12.createElement(React12.Fragment, null, data.messages.map(function(message, index) {
        var _message_text_graphic;
        /* @__PURE__ */ return React12.createElement("div", {
            key: "review-footer-message-".concat(index)
        }, message.seoStructuredData && /* @__PURE__ */ React12.createElement(UitkHeading5, {
            size: 7,
            tag: "h5",
            itemScope: message.seoStructuredData.itemscope,
            itemProp: message.seoStructuredData.itemprop,
            itemType: message.seoStructuredData.itemtype,
            hidden: true
        }, /* @__PURE__ */ React12.createElement("span", {
            itemProp: "name"
        }, message.seoStructuredData.content)), message.text && /* @__PURE__ */ React12.createElement(UitkLayoutFlex2, {
            space: "two"
        }, message.text.__typename === "EGDSGraphicText" && ((_message_text_graphic = message.text.graphic) === null || _message_text_graphic === void 0 ? void 0 : _message_text_graphic.__typename) === "Mark" && /* @__PURE__ */ React12.createElement(UitkLayoutFlexItem2, null, /* @__PURE__ */ React12.createElement(UitkMarkFlag, {
            name: message.text.graphic.id
        })), /* @__PURE__ */ React12.createElement(UitkLayoutFlexItem2, null, /* @__PURE__ */ React12.createElement(UitkText8, {
            size: 200,
            theme: "default"
        }, message.text.text))));
    }));
};
PropertyReviewFooterSection.displayName = "PropertyReviewFooterSectionFragment";
PropertyReviewFooterSection.fragment = fragment9;
// src/components/__private/__fragments/property-review-region.tsx
import React13 from "react";
import { gql as gql13 } from "@apollo/client";
import { UitkMarkFlag as UitkMarkFlag2 } from "uitk-react-mark";
var fragment10 = gql13(_templateObject14());
var PropertyReviewRegion = function(param) {
    var data = param.data;
    if (!data || !data.reviewRegion) {
        return null;
    }
    return /* @__PURE__ */ React13.createElement(UitkMarkFlag2, {
        name: data.reviewRegion.id
    });
};
PropertyReviewRegion.displayName = "PropertyReviewRegion";
PropertyReviewRegion.fragment = fragment10;
// src/components/__private/__fragments/property-review-source.tsx
import React14 from "react";
import { gql as gql14 } from "@apollo/client";
import { UitkLayoutFlex as UitkLayoutFlex3, UitkLayoutFlexItem as UitkLayoutFlexItem3 } from "uitk-react-layout-flex";
import { UitkMark, UitkMarkSize } from "uitk-react-mark";
import { UitkSpacing as UitkSpacing9 } from "uitk-react-spacing";
import { UitkText as UitkText9 } from "uitk-react-text";
var __PropertyReviewSourceFragment = gql14(_templateObject15());
var PropertyReviewSource = function(param) {
    var data = param.data;
    var _ref = data.propertyReviewSource || {}, text = _ref.text, graphic = _ref.graphic, accessibilityLabel = _ref.accessibilityLabel;
    if (!text || !text.value) {
        return null;
    }
    var _ref1 = graphic || {}, id = _ref1.id, description = _ref1.description, url = _ref1.url;
    return /* @__PURE__ */ React14.createElement(React14.Fragment, null, /* @__PURE__ */ React14.createElement(UitkLayoutFlex3, {
        space: "one",
        tabIndex: -1,
        alignItems: "end"
    }, /* @__PURE__ */ React14.createElement(UitkLayoutFlexItem3, null, /* @__PURE__ */ React14.createElement(UitkText9, {
        size: 200,
        theme: "default",
        overflow: "truncate",
        "data-stid": "property-source"
    }, text.value)), /* @__PURE__ */ React14.createElement(UitkLayoutFlexItem3, null, /* @__PURE__ */ React14.createElement(React14.Fragment, null, id && /* @__PURE__ */ React14.createElement(UitkSpacing9, {
        padding: {
            blockend: "one"
        }
    }, /* @__PURE__ */ React14.createElement("div", null, /* @__PURE__ */ React14.createElement(UitkMark, {
        name: id,
        size: UitkMarkSize.EXTRA_SMALL,
        description: description
    }))), !id && (url === null || url === void 0 ? void 0 : url.value) && /* @__PURE__ */ React14.createElement(UitkMark, {
        url: url.value,
        size: UitkMarkSize.EXTRA_SMALL,
        description: description
    })))), accessibilityLabel && /* @__PURE__ */ React14.createElement(UitkText9, {
        className: "is-visually-hidden"
    }, accessibilityLabel));
};
PropertyReviewSource.displayName = "PropertyReviewSource";
PropertyReviewSource.fragment = __PropertyReviewSourceFragment;
// src/components/__private/__fragments/review-theme.tsx
import React15 from "react";
import { gql as gql15 } from "@apollo/client";
import { UitkIcon as UitkIcon5, UitkIconSize as UitkIconSize4 } from "uitk-react-icons";
import { UitkSpacing as UitkSpacing10 } from "uitk-react-spacing";
import { UitkText as UitkText10 } from "uitk-react-text";
var __ReviewThemeFragment = gql15(_templateObject16());
var ReviewTheme = function(param) {
    var data = param.data, themeUniqueId = param.themeUniqueId;
    var label = data.label, icon = data.icon;
    if (!icon || !label) {
        return null;
    }
    return /* @__PURE__ */ React15.createElement(UitkSpacing10, {
        margin: {
            blockstart: "two"
        }
    }, /* @__PURE__ */ React15.createElement("div", null, /* @__PURE__ */ React15.createElement(UitkIcon5, {
        "aria-hidden": true,
        size: UitkIconSize4.SMALL,
        name: icon.id,
        id: "".concat(icon.id, "-").concat(themeUniqueId)
    }), /* @__PURE__ */ React15.createElement(UitkSpacing10, {
        padding: {
            inlinestart: "two"
        }
    }, /* @__PURE__ */ React15.createElement(UitkText10, {
        size: 200,
        theme: "default",
        inline: true
    }, label))));
};
ReviewTheme.displayName = "ReviewTheme";
ReviewTheme.fragment = __ReviewThemeFragment;
// src/components/__private/__fragments/review-translation-info-fragment.tsx
import React16 from "react";
import { gql as gql16 } from "@apollo/client";
import { useClickTracker as useClickTracker6 } from "@shared-ui/clickstream-analytics-context";
import { UitkLink as UitkLink4 } from "uitk-react-link";
import { UitkSpacing as UitkSpacing11 } from "uitk-react-spacing";
import { UitkText as UitkText11 } from "uitk-react-text";
var __ReviewTranslationInfoFragment = gql16(_templateObject17());
var ReviewTranslationInfo = function(param) {
    var data = param.data, isLoading = param.isLoading, isTranslated = param.isTranslated, onTranslateClicked = param.onTranslateClicked;
    var translationInfo = data.translationInfo;
    var tracker = useClickTracker6();
    if (!translationInfo) {
        return null;
    }
    var trackedOnTranslateReviewClick = function() {
        tracker(TRANSLATE_TRACKER.rfrr, TRANSLATE_TRACKER.link);
        onTranslateClicked();
    };
    if (isLoading) {
        return /* @__PURE__ */ React16.createElement(UitkText11, {
            size: 200,
            theme: "default"
        }, translationInfo.loadingTranslationText);
    }
    return /* @__PURE__ */ React16.createElement(React16.Fragment, null, !isTranslated ? /* @__PURE__ */ React16.createElement(UitkSpacing11, {
        margin: {
            block: "two"
        }
    }, /* @__PURE__ */ React16.createElement(UitkLink4, {
        className: "uitk-type-300 ",
        size: "small",
        inline: true
    }, /* @__PURE__ */ React16.createElement("button", {
        type: "button",
        onClick: trackedOnTranslateReviewClick
    }, translationInfo.translationCallToActionLabel))) : /* @__PURE__ */ React16.createElement(React16.Fragment, null, /* @__PURE__ */ React16.createElement(UitkText11, {
        inline: true,
        size: 200,
        theme: "default"
    }, translationInfo.translatedBy.description), /* @__PURE__ */ React16.createElement(UitkSpacing11, {
        margin: {
            block: "two"
        }
    }, /* @__PURE__ */ React16.createElement(UitkLink4, {
        className: "uitk-type-300",
        size: "small",
        inline: true
    }, /* @__PURE__ */ React16.createElement("button", {
        type: "button",
        onClick: onTranslateClicked
    }, translationInfo.seeOriginalText)))));
};
ReviewTranslationInfo.displayName = "ReviewTranslationInfo";
ReviewTranslationInfo.fragment = __ReviewTranslationInfoFragment;
// src/components/__private/__fragments/travelers.tsx
import React17 from "react";
import { gql as gql17 } from "@apollo/client";
import { UitkText as UitkText12 } from "uitk-react-text";
var __TravelersFragment = gql17(_templateObject18());
var Travelers = function(param) {
    var data = param.data;
    var travelers = data.travelers;
    if (!(travelers === null || travelers === void 0 ? void 0 : travelers.length)) {
        return null;
    }
    return /* @__PURE__ */ React17.createElement(UitkText12, {
        size: 300,
        theme: "default"
    }, travelers.join(", "));
};
Travelers.displayName = "Travelers";
Travelers.fragment = __TravelersFragment;
// src/components/__private/__fragments/review-parent.tsx
var fragment11 = gql18(_templateObject19(), PropertyReviewAuthor.fragment, Photos.fragment, Travelers.fragment, ReviewTheme.fragment, feedback_indicator_default.fragment, ReviewTranslationInfo.fragment, PropertyReviewSource.fragment, PropertyReviewRegion.fragment, PropertyReviewFooterSection.fragment);
var translateReviewQuery = gql18(_templateObject20());
var ReviewParent = function(param) {
    var data = param.data, children = param.children, propertyId = param.propertyId, reviewIndex = param.reviewIndex, reviewsPage = param.reviewsPage;
    var _translateData_propertyInfo, _translateData_propertyInfo_review, _translateData_propertyInfo1, _translateData_propertyInfo_review1;
    var id = data.id, superlative = data.superlative, themes = data.themes, submissionTime = data.submissionTime, title = data.title, text = data.text, seeMoreAnalytics = data.seeMoreAnalytics, reviewScoreWithDescription = data.reviewScoreWithDescription, impressionAnalytics = data.impressionAnalytics, reviewFooter = data.reviewFooter;
    var _React18_useState = _slicedToArray(React18.useState(false), 2), isTranslated = _React18_useState[0], hasBeenTranslated = _React18_useState[1];
    var _React18_useState1 = _slicedToArray(React18.useState(false), 2), isExpandoVisible = _React18_useState1[0], setIsExpandoVisible = _React18_useState1[1];
    var context = useBexApi4().context;
    var _useLazyQuery = _slicedToArray(useLazyQuery(translateReviewQuery), 2), translateReviewQueryCallable = _useLazyQuery[0], result = _useLazyQuery[1];
    var translateData = result.data;
    var called = result.called, loading = result.loading;
    var clickTracker = useClickTracker7();
    var handleExpandoClick = React18.useCallback(function() {
        if (!isExpandoVisible && seeMoreAnalytics && seeMoreAnalytics.referrerId && reviewsPage) {
            clickTracker(seeMoreAnalytics.referrerId.concat(reviewsPage), seeMoreAnalytics.linkName);
        }
        setIsExpandoVisible(!isExpandoVisible);
    }, [
        isExpandoVisible,
        clickTracker,
        seeMoreAnalytics,
        reviewsPage
    ]);
    var onTranslateClicked = function() {
        if (!called) {
            translateReviewQueryCallable({
                variables: {
                    context: context,
                    propertyId: propertyId,
                    reviewId: id,
                    locale: context.locale
                }
            });
        }
        hasBeenTranslated(!isTranslated);
    };
    var translatedText = translateData === null || translateData === void 0 ? void 0 : (_translateData_propertyInfo = translateData.propertyInfo) === null || _translateData_propertyInfo === void 0 ? void 0 : (_translateData_propertyInfo_review = _translateData_propertyInfo.review) === null || _translateData_propertyInfo_review === void 0 ? void 0 : _translateData_propertyInfo_review.translatedText;
    var translatedTitle = translateData === null || translateData === void 0 ? void 0 : (_translateData_propertyInfo1 = translateData.propertyInfo) === null || _translateData_propertyInfo1 === void 0 ? void 0 : (_translateData_propertyInfo_review1 = _translateData_propertyInfo1.review) === null || _translateData_propertyInfo_review1 === void 0 ? void 0 : _translateData_propertyInfo_review1.translatedTitle;
    var titleText = isTranslated && translatedTitle ? translatedTitle : title;
    var article = /* @__PURE__ */ React18.createElement("article", {
        itemProp: "review",
        itemScope: true,
        itemType: "http://schema.org/Review",
        id: id
    }, superlative && /* @__PURE__ */ React18.createElement(UitkSpacing12, {
        padding: {
            blockend: "two"
        }
    }, /* @__PURE__ */ React18.createElement("section", {
        itemProp: "reviewRating",
        itemScope: true,
        itemType: "http://schema.org/Rating",
        "data-stid": "property-reviews-parent__section-superlative"
    }, (reviewScoreWithDescription === null || reviewScoreWithDescription === void 0 ? void 0 : reviewScoreWithDescription.value) && /* @__PURE__ */ React18.createElement(UitkHeading6, {
        tag: "h3",
        size: 5,
        "aria-label": reviewScoreWithDescription.label || ""
    }, /* @__PURE__ */ React18.createElement("span", {
        itemProp: "ratingValue"
    }, reviewScoreWithDescription.value)))), /* @__PURE__ */ React18.createElement("section", null, /* @__PURE__ */ React18.createElement(PropertyReviewAuthor, {
        data: data
    }), /* @__PURE__ */ React18.createElement(Travelers, {
        data: data
    }), /* @__PURE__ */ React18.createElement(UitkText13, {
        size: 300,
        theme: "default"
    }, /* @__PURE__ */ React18.createElement("span", {
        itemProp: "datePublished"
    }, submissionTime.longDateFormat))), themes && themes.length > 0 && /* @__PURE__ */ React18.createElement(UitkSpacing12, {
        margin: {
            block: "two"
        }
    }, /* @__PURE__ */ React18.createElement("section", {
        "data-stid": "property-reviews-parent__section-sentiments"
    }, themes.map(function(theme, index) {
        return /* @__PURE__ */ React18.createElement(ReviewTheme, {
            themeUniqueId: "".concat(id, "-").concat(index),
            data: theme,
            key: "review-theme-".concat(index)
        });
    }))), /* @__PURE__ */ React18.createElement(ReviewTranslationInfo, {
        data: data,
        isLoading: loading,
        isTranslated: isTranslated,
        onTranslateClicked: onTranslateClicked
    }), (title || text) && /* @__PURE__ */ React18.createElement(UitkSpacing12, {
        margin: {
            block: "two"
        }
    }, /* @__PURE__ */ React18.createElement("section", null, titleText && /* @__PURE__ */ React18.createElement(UitkHeading6, {
        tag: "h5",
        size: 6,
        "data-stid": "review_section_title"
    }, /* @__PURE__ */ React18.createElement("span", {
        itemProp: "name"
    }, titleText)), /* @__PURE__ */ React18.createElement(UitkSpacing12, {
        padding: {
            blockstart: "two"
        }
    }, /* @__PURE__ */ React18.createElement(UitkExpandoPeek, {
        isVisible: isExpandoVisible,
        lines: 5,
        handleClick: handleExpandoClick
    }, /* @__PURE__ */ React18.createElement(UitkText13, {
        size: 300,
        theme: "default"
    }, /* @__PURE__ */ React18.createElement("span", {
        itemProp: "description"
    }, isTranslated && translatedText ? translatedText : text)))))), /* @__PURE__ */ React18.createElement(Photos, {
        data: data,
        reviewsPage: reviewsPage
    }), /* @__PURE__ */ React18.createElement(UitkSpacing12, {
        margin: {
            block: "two"
        }
    }, /* @__PURE__ */ React18.createElement("section", null, /* @__PURE__ */ React18.createElement(UitkLayoutFlex4, {
        justifyContent: "space-between",
        alignItems: "end"
    }, /* @__PURE__ */ React18.createElement(UitkLayoutFlexItem4, null, /* @__PURE__ */ React18.createElement(UitkLayoutFlex4, {
        direction: "column"
    }, reviewFooter && /* @__PURE__ */ React18.createElement(UitkLayoutFlexItem4, null, /* @__PURE__ */ React18.createElement(UitkLayoutFlex4, {
        space: "two",
        direction: "row"
    }, /* @__PURE__ */ React18.createElement(PropertyReviewFooterSection, {
        data: reviewFooter
    }))), /* @__PURE__ */ React18.createElement(UitkLayoutFlexItem4, null, /* @__PURE__ */ React18.createElement(UitkSpacing12, {
        margin: {
            blockstart: "three"
        }
    }, /* @__PURE__ */ React18.createElement(UitkLayoutFlex4, {
        justifyContent: "start"
    }, /* @__PURE__ */ React18.createElement(UitkLayoutFlexItem4, null, /* @__PURE__ */ React18.createElement(feedback_indicator_default, {
        reviewId: id,
        reviewIndex: reviewIndex,
        data: data,
        reviewsPage: reviewsPage
    })), /* @__PURE__ */ React18.createElement(UitkLayoutFlexItem4, null, children)))))), /* @__PURE__ */ React18.createElement(UitkLayoutFlexItem4, null, /* @__PURE__ */ React18.createElement(PropertyReviewSource, {
        data: data
    }))))));
    var _ref = impressionAnalytics || {}, _ref_referrerId = _ref.referrerId, referrerId = _ref_referrerId === void 0 ? "" : _ref_referrerId, tmp = _ref.event, link = tmp === void 0 ? "" : tmp;
    if (reviewsPage === "ReviewsOverlay" /* REVIEWS_OVERLAY */  && referrerId && link) {
        return /* @__PURE__ */ React18.createElement(IntersectionTracker, {
            trackOnce: true,
            referrerId: referrerId,
            linkName: link
        }, article);
    }
    return article;
};
ReviewParent.displayName = "ReviewParent";
ReviewParent.fragment = fragment11;
var review_parent_default = ReviewParent;
// src/components/__private/__fragments/property-reviews-list-fragment.ts
var PropertyReviewsListFragment = gql19(_templateObject21(), review_parent_default.fragment, review_child_default.fragment, NoResultsMessage.fragment);
// src/components/__private/__fragments/property-reviews-list.tsx
var PropertyReviewsList = function(param) {
    var data = param.data, fetchMore = param.fetchMore, hideManagementResponse = param.hideManagementResponse, propertyId = param.propertyId, _param_showLoadMoreCTA = param.showLoadMoreCTA, showLoadMoreCTA = _param_showLoadMoreCTA === void 0 ? true : _param_showLoadMoreCTA, size = param.size, reviewsPage = param.reviewsPage;
    var cache = useApolloClient().cache;
    var reviews = data.reviews, summary = data.summary;
    var paginateAction = summary === null || summary === void 0 ? void 0 : summary.paginateAction;
    var _ref = (paginateAction === null || paginateAction === void 0 ? void 0 : paginateAction.analytics) || {}, referrerId = _ref.referrerId, linkName = _ref.linkName;
    var tracker = useClickTracker8();
    var exposure = useExperiment("Free_text_search_of_reviews_in_reviews_overlay").exposure;
    var freeTextSearchBucketed = exposure.bucket === 1 || exposure.bucket === 2;
    var actionReason = freeTextSearchBucketed && showLoadMoreCTA ? "Free text unfiltered" /* FREE_TEXT_UNFILTERED */  : "Free text filtered" /* FREE_TEXT_FILTERED */ ;
    var loadMoreReviews = function() {
        if (referrerId && linkName) {
            tracker(referrerId, linkName);
        }
        fetchMore({
            variables: {
                searchCriteria: {
                    secondary: {
                        counts: [
                            {
                                id: "startIndex",
                                value: reviews.length
                            },
                            {
                                id: "size",
                                value: size
                            }
                        ]
                    }
                }
            },
            updateQuery: function(prev, param) {
                var fetchMoreResult = param.fetchMoreResult;
                if (!fetchMoreResult) {
                    return prev;
                }
                return _objectSpreadProps(_objectSpread({}, prev), {
                    propertyInfo: _objectSpreadProps(_objectSpread({}, prev.propertyInfo), {
                        reviewInfo: _objectSpreadProps(_objectSpread({}, prev.propertyInfo.reviewInfo), {
                            summary: _objectSpread({}, prev.propertyInfo.reviewInfo.summary, fetchMoreResult.propertyInfo.reviewInfo.summary),
                            reviews: _toConsumableArray(prev.propertyInfo.reviewInfo.reviews).concat(_toConsumableArray(fetchMoreResult.propertyInfo.reviewInfo.reviews))
                        })
                    })
                });
            }
        });
    };
    var getHideReview = function(reviewId) {
        return function() {
            var cacheId = cache.identify({
                id: reviewId,
                __typename: "PropertyReview"
            });
            cache.evict({
                id: cacheId
            });
            cache.gc();
        };
    };
    var reviewContent = /* @__PURE__ */ React19.createElement(UitkCard2, null, reviews && reviews.length > 0 && reviews.map(function(review, index) {
        var managementResponses = review.managementResponses, id = review.id, brandType = review.brandType;
        return /* @__PURE__ */ React19.createElement(UitkCardContentSection, {
            border: "bottom",
            key: "review-".concat(id)
        }, /* @__PURE__ */ React19.createElement(review_parent_default, {
            data: review,
            propertyId: propertyId,
            reviewIndex: index + 1,
            reviewsPage: reviewsPage
        }, review.contentDirectFeedbackPromptId && /* @__PURE__ */ React19.createElement(ContentDirectFeedbackCallToAction, {
            dialogId: id,
            feedbackContext: [
                {
                    key: "brand",
                    value: brandType || ""
                },
                {
                    key: "property_id",
                    value: propertyId
                },
                {
                    key: "review_id",
                    value: id
                }
            ],
            hideReview: getHideReview(id),
            inputs: {
                id: review.contentDirectFeedbackPromptId
            }
        })), !hideManagementResponse && managementResponses.length > 0 && /* @__PURE__ */ React19.createElement(review_child_default, {
            data: review.managementResponses[0]
        }));
    }), /* @__PURE__ */ React19.createElement(NoResultsMessage, {
        data: data
    }));
    var reviewContentWithImpression = /* @__PURE__ */ React19.createElement(EgClickstreamImpressionTracker, {
        eventData: reviewsViewedEvent(reviews, actionReason)
    }, reviewContent);
    return /* @__PURE__ */ React19.createElement("section", null, freeTextSearchBucketed ? reviewContentWithImpression : reviewContent, paginateAction && showLoadMoreCTA && /* @__PURE__ */ React19.createElement(UitkSpacing13, {
        margin: {
            block: "three"
        }
    }, /* @__PURE__ */ React19.createElement("div", {
        className: "uitk-type-center"
    }, /* @__PURE__ */ React19.createElement(UitkSecondaryButton, {
        onClick: loadMoreReviews
    }, paginateAction === null || paginateAction === void 0 ? void 0 : paginateAction.text))));
};
PropertyReviewsList.displayName = "PropertyReviewsList";
PropertyReviewsList.fragment = PropertyReviewsListFragment;
var property_reviews_list_default = PropertyReviewsList;
// src/components/__private/defaults.ts
var DEFAULT_STARTING_INDEX = 0;
var DEFAULT_PAGINATION_SIZE = 10;
var DEFAULT_REVIEWS_SORT = "NEWEST_TO_OLDEST_BY_LANGUAGE";
var DEFAULT_SEARCH_INPUT = "";
// src/components/property-reviews-list.tsx
var __ReviewQuery = gql20(_templateObject22(), PropertyReviewsListFragment);
var DEFAULT_STARTING_INDEX2 = 0;
var DEFAULT_PAGINATION_SIZE2 = 10;
var PropertyReviewsList2 = React20.memo(function(props) {
    var _inputs_pagination, _inputs_pagination1;
    var searchCriteria = props.inputs.searchCriteria, inputs = _objectWithoutProperties(props.inputs, [
        "searchCriteria"
    ]);
    var context = useBexApi5().context;
    var propertyId = String(inputs.propertyId);
    var size = (inputs === null || inputs === void 0 ? void 0 : (_inputs_pagination = inputs.pagination) === null || _inputs_pagination === void 0 ? void 0 : _inputs_pagination.size) || DEFAULT_PAGINATION_SIZE2;
    var startingIndex = (inputs === null || inputs === void 0 ? void 0 : (_inputs_pagination1 = inputs.pagination) === null || _inputs_pagination1 === void 0 ? void 0 : _inputs_pagination1.startingIndex) || DEFAULT_STARTING_INDEX2;
    var variables = {
        context: context,
        propertyId: propertyId,
        searchCriteria: {
            primary: searchCriteria.primary,
            secondary: {
                booleans: [
                    {
                        id: "includeRecentReviews",
                        value: true
                    },
                    {
                        id: "includeRatingsOnlyReviews",
                        value: true
                    }
                ],
                counts: [
                    {
                        id: "startIndex",
                        value: startingIndex
                    },
                    {
                        id: "size",
                        value: size
                    }
                ],
                selections: [
                    {
                        id: "sortBy",
                        value: DEFAULT_REVIEWS_SORT
                    }
                ]
            }
        }
    };
    var _useQuery2 = useQuery2(__ReviewQuery, {
        variables: variables,
        errorPolicy: "all",
        fetchPolicy: "cache-first"
    }), data = _useQuery2.data, error = _useQuery2.error, loading = _useQuery2.loading, fetchMore = _useQuery2.fetchMore;
    if (loading || error || !data) {
        return null;
    }
    var paginationFetch = buildFetchMoreReviews(fetchMore, variables);
    return /* @__PURE__ */ React20.createElement(property_reviews_list_default, {
        propertyId: propertyId,
        size: size,
        data: data.propertyInfo.reviewInfo,
        fetchMore: paginationFetch
    });
});
PropertyReviewsList2.displayName = "PropertyReviewsList";
// src/components/property-reviews-summary.tsx
import React32 from "react";
import { gql as gql31, useQuery as useQuery3 } from "@apollo/client";
import { useBexApi as useBexApi6 } from "@shared-ui/bex-api-context";
// src/components/__private/__fragments/property-reviews-summary-fragment.tsx
import React31 from "react";
import { gql as gql30 } from "@apollo/client";
// ../internal/src/components/lodging-enriched-message/lodging-enriched-message.tsx
import React21 from "react";
import { gql as gql21 } from "@apollo/client";
import { UitkIcon as UitkIcon6, UitkIconSize as UitkIconSize5 } from "uitk-react-icons";
import { UitkLayoutFlex as UitkLayoutFlex5 } from "uitk-react-layout-flex";
import { UitkLayoutGrid as UitkLayoutGrid2, UitkLayoutGridItem as UitkLayoutGridItem2 } from "uitk-react-layout-grid";
import { UitkMark as UitkMark2, UitkMarkSize as UitkMarkSize2 } from "uitk-react-mark";
import { UitkSpacing as UitkSpacing14 } from "uitk-react-spacing";
import { UitkText as UitkText14 } from "uitk-react-text";
import { UitkUnformattedHtml } from "uitk-react-unformatted-html";
var fragment12 = gql21(_templateObject23());
var highlightedMessagesThemeToUitkTextTheme = {
    AGGRESSIVE: "negative",
    HIGHLIGHT: "positive",
    LOYALTY: "loyalty"
};
var highlightedMessagesThemeToUitkTextWeight = {
    STRONG: "bold"
};
var LodgingEnrichedMessage = function(param) {
    var data = param.data, markSize = param.markSize, textSize = param.textSize;
    var _egdsMark_url;
    var subText = data.subText, value = data.value, theme = data.theme, icon = data.icon, mark = data.mark, egdsMark = data.egdsMark, state = data.state, accessibilityLabel = data.accessibilityLabel;
    if (!value) {
        return null;
    }
    var stateTheme = state || theme;
    return /* @__PURE__ */ React21.createElement(UitkLayoutGrid2, null, /* @__PURE__ */ React21.createElement(UitkLayoutGridItem2, null, /* @__PURE__ */ React21.createElement(UitkLayoutFlex5, {
        alignItems: "center"
    }, mark && !egdsMark && /* @__PURE__ */ React21.createElement(UitkSpacing14, {
        margin: {
            inlineend: "two"
        }
    }, /* @__PURE__ */ React21.createElement(UitkMark2, {
        name: mark.id,
        size: markSize
    })), icon && /* @__PURE__ */ React21.createElement(UitkSpacing14, {
        margin: {
            inlineend: "two"
        }
    }, /* @__PURE__ */ React21.createElement(UitkIcon6, {
        name: icon.id,
        size: icon.size ? UitkIconSize5[icon.size] : UitkIconSize5.MEDIUM
    })), egdsMark && /* @__PURE__ */ React21.createElement(UitkSpacing14, {
        margin: {
            inlineend: "two"
        }
    }, /* @__PURE__ */ React21.createElement(UitkMark2, {
        url: (_egdsMark_url = egdsMark.url) === null || _egdsMark_url === void 0 ? void 0 : _egdsMark_url.value,
        size: markSize !== null && markSize !== void 0 ? markSize : UitkMarkSize2.MEDIUM
    })), accessibilityLabel && /* @__PURE__ */ React21.createElement("span", {
        className: "is-visually-hidden"
    }, accessibilityLabel), /* @__PURE__ */ React21.createElement("div", null, /* @__PURE__ */ React21.createElement(UitkUnformattedHtml, {
        htmlToParse: value,
        plainTextElement: function(props) {
            return /* @__PURE__ */ React21.createElement(UitkText14, {
                size: textSize,
                weight: stateTheme && highlightedMessagesThemeToUitkTextWeight[stateTheme] || void 0,
                theme: stateTheme && highlightedMessagesThemeToUitkTextTheme[stateTheme] || void 0
            }, props.children);
        }
    })))), subText && /* @__PURE__ */ React21.createElement(UitkLayoutGridItem2, null, /* @__PURE__ */ React21.createElement(UitkText14, {
        size: 200,
        theme: "default"
    }, subText)));
};
LodgingEnrichedMessage.fragment = fragment12;
LodgingEnrichedMessage.displayName = "LodgingEnrichedMessage";
// ../internal/src/components/property-review-summary/property-reviews-breakdown.tsx
import React30 from "react";
import { gql as gql29 } from "@apollo/client";
import { Experiment as Experiment2, ExperimentControl as ExperimentControl2, ExperimentVariant as ExperimentVariant2 } from "@shared-ui/experiment-context";
import { UitkLayoutFlex as UitkLayoutFlex8, UitkLayoutFlexItem as UitkLayoutFlexItem7 } from "uitk-react-layout-flex";
import { UitkLink as UitkLink7 } from "uitk-react-link";
import { UitkSpacing as UitkSpacing18 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading8, UitkText as UitkText17 } from "uitk-react-text";
// ../internal/src/components/property-review-summary/utils/structured-data.ts
var getStructuredDataProps = function(itemProp, required) {
    if (!required) {
        return null;
    }
    var baseProps = {
        itemProp: itemProp
    };
    if (itemProp === "aggregateRating") {
        baseProps = _objectSpreadProps(_objectSpread({}, baseProps), {
            itemScope: true,
            itemType: "http://schema.org/AggregateRating"
        });
    }
    return baseProps;
};
// ../internal/src/components/property-review-summary/__private/__fragments/rating-counts.tsx
import React22 from "react";
import { gql as gql22 } from "@apollo/client";
import { UitkLayoutFlex as UitkLayoutFlex6, UitkLayoutFlexItem as UitkLayoutFlexItem5 } from "uitk-react-layout-flex";
import { UitkProgressBar } from "uitk-react-progress-bar";
import { UitkSpacing as UitkSpacing15 } from "uitk-react-spacing";
var fragment13 = gql22(_templateObject24());
var RatingCounts = function(param) {
    var data = param.data;
    var ratingCounts = data.ratingCounts;
    if (!ratingCounts || ratingCounts.length === 0) {
        return null;
    }
    return /* @__PURE__ */ React22.createElement(UitkSpacing15, {
        margin: {
            blockstart: "two",
            blockend: "four"
        }
    }, /* @__PURE__ */ React22.createElement(UitkLayoutFlex6, {
        space: "two",
        direction: "column"
    }, ratingCounts.map(function(ratingCount) {
        /* @__PURE__ */ return React22.createElement(UitkLayoutFlexItem5, {
            minWidth: "full_width",
            key: "rating-".concat(ratingCount.rating)
        }, /* @__PURE__ */ React22.createElement(UitkProgressBar, {
            accessibilityLabel: (ratingCount === null || ratingCount === void 0 ? void 0 : ratingCount.accessibilityLabel) || "",
            percent: ratingCount.percent,
            progressDescription: ratingCount.count.formatted,
            title: ratingCount.description
        }));
    })));
};
RatingCounts.displayName = "RatingCounts";
RatingCounts.fragment = fragment13;
// ../internal/src/components/property-review-summary/__private/__fragments/summary-details.tsx
import React23 from "react";
import { gql as gql23 } from "@apollo/client";
import { useClickTracker as useClickTracker9 } from "@shared-ui/clickstream-analytics-context";
import { UitkLayoutFlex as UitkLayoutFlex7, UitkLayoutFlexItem as UitkLayoutFlexItem6 } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing16 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading7, UitkText as UitkText15 } from "uitk-react-text";
var fragment14 = gql23(_templateObject25());
var SummaryDetails = function(param) {
    var data = param.data;
    var _reviewSummaryDetails_;
    var reviewSummaryDetails = data.reviewSummaryDetails;
    var track = useClickTracker9();
    React23.useEffect(function() {
        var _reviewSummaryDetails_;
        var cleanlinessRate = reviewSummaryDetails === null || reviewSummaryDetails === void 0 ? void 0 : (_reviewSummaryDetails_ = reviewSummaryDetails[0]) === null || _reviewSummaryDetails_ === void 0 ? void 0 : _reviewSummaryDetails_.formattedRatingOutOfMaxA11y.value;
        if (cleanlinessRate) {
            track("HOT.HIS.cleanliness.".concat(cleanlinessRate), "Property cleanliness score");
        }
    }, [
        reviewSummaryDetails === null || reviewSummaryDetails === void 0 ? void 0 : (_reviewSummaryDetails_ = reviewSummaryDetails[0]) === null || _reviewSummaryDetails_ === void 0 ? void 0 : _reviewSummaryDetails_.formattedRatingOutOfMaxA11y.value
    ]);
    if (!reviewSummaryDetails || reviewSummaryDetails.length === 0) {
        return null;
    }
    return /* @__PURE__ */ React23.createElement(UitkLayoutFlex7, {
        wrap: "wrap"
    }, reviewSummaryDetails.map(function(reviewSummaryDetailItem) {
        var formattedRatingOutOfMaxA11y = reviewSummaryDetailItem.formattedRatingOutOfMaxA11y, label = reviewSummaryDetailItem.label;
        var _formattedRatingOutOfMaxA11y_accessibilityLabel;
        return /* @__PURE__ */ React23.createElement(UitkLayoutFlexItem6, {
            minWidth: "half_width",
            key: "category-".concat(label)
        }, /* @__PURE__ */ React23.createElement(UitkSpacing16, {
            margin: {
                block: "three"
            }
        }, /* @__PURE__ */ React23.createElement(UitkLayoutFlex7, {
            direction: "column"
        }, /* @__PURE__ */ React23.createElement(UitkHeading7, {
            "aria-label": (_formattedRatingOutOfMaxA11y_accessibilityLabel = formattedRatingOutOfMaxA11y.accessibilityLabel) !== null && _formattedRatingOutOfMaxA11y_accessibilityLabel !== void 0 ? _formattedRatingOutOfMaxA11y_accessibilityLabel : void 0,
            tag: "h3",
            size: 5
        }, formattedRatingOutOfMaxA11y.value), /* @__PURE__ */ React23.createElement(UitkText15, {
            size: 300
        }, label))));
    }));
};
SummaryDetails.displayName = "SummaryDetails";
SummaryDetails.fragment = fragment14;
// ../internal/src/components/property-review-summary/__private/__fragments/property-filtered-reviews-dialog.tsx
import React28 from "react";
import { gql as gql27 } from "@apollo/client";
import { useClickTracker as useClickTracker11 } from "@shared-ui/clickstream-analytics-context";
import { useDialog as useDialog3 } from "@shared-ui/dialog-context";
import { UitkDialogContent as UitkDialogContent2 } from "uitk-react-dialog";
import { UitkSheet as UitkSheet2 } from "uitk-react-sheet";
// ../internal/src/components/egds/egds-toolbar/egds-dialog-toolbar.tsx
import React24 from "react";
import { gql as gql24 } from "@apollo/client";
import { UitkToolbar as UitkToolbar2 } from "uitk-react-toolbar";
var fragment15 = gql24(_templateObject26());
var EGDSDialogToolbar = function(param) {
    var data = param.data, toolbarType = param.toolbarType, toolbarAction = param.toolbarAction;
    var _data_closeText;
    return /* @__PURE__ */ React24.createElement(UitkToolbar2, {
        toolbarTitle: data.title,
        navigationContent: {
            onClick: toolbarAction,
            navType: toolbarType,
            navIconLabel: (_data_closeText = data.closeText) !== null && _data_closeText !== void 0 ? _data_closeText : void 0
        }
    });
};
EGDSDialogToolbar.fragment = fragment15;
EGDSDialogToolbar.displayName = "EGDSDialogToolbar";
// ../internal/src/components/lodging-dialog-trigger-message/lodging-dialog-trigger-message.tsx
import React26 from "react";
import { gql as gql26 } from "@apollo/client";
import { useClickTracker as useClickTracker10 } from "@shared-ui/clickstream-analytics-context";
import { UitkLink as UitkLink5 } from "uitk-react-link";
// ../internal/src/components/lodging-egds-icon/lodging-egds-icon.tsx
import React25 from "react";
import { gql as gql25 } from "@apollo/client";
import { UitkIcon as UitkIcon7, UitkIconSize as UitkIconSize6 } from "uitk-react-icons";
var fragment16 = gql25(_templateObject27());
var LodgingEGDSIcon = function(param) {
    var ariaHidden = param.ariaHidden, data = param.data;
    var description = data.description, id = data.id, size = data.size, theme = data.theme;
    var _ref;
    return /* @__PURE__ */ React25.createElement(UitkIcon7, {
        description: ariaHidden ? void 0 : description,
        title: ariaHidden ? void 0 : description,
        id: id,
        name: id,
        size: (_ref = size && UitkIconSize6[size]) !== null && _ref !== void 0 ? _ref : void 0,
        theme: theme !== null && theme !== void 0 ? theme : void 0
    });
};
LodgingEGDSIcon.fragment = fragment16;
LodgingEGDSIcon.displayName = "LodgingEGDSIcon";
// ../internal/src/components/lodging-dialog-trigger-message/lodging-dialog-trigger-message.tsx
var fragment17 = gql26(_templateObject28(), LodgingEGDSIcon.fragment);
var LodgingDialogTriggerMessage = function(param) {
    var onClickAction = param.onClickAction, triggerRef = param.triggerRef, _param_data = param.data, value = _param_data.value, accessibilityLabel = _param_data.accessibilityLabel, icon = _param_data.icon, clientSideAnalytics = _param_data.clientSideAnalytics;
    var track = useClickTracker10();
    var onClick = function() {
        if (clientSideAnalytics) {
            track(clientSideAnalytics.referrerId, clientSideAnalytics.linkName);
        }
        onClickAction();
    };
    return /* @__PURE__ */ React26.createElement(UitkLink5, null, /* @__PURE__ */ React26.createElement("button", {
        type: "button",
        ref: triggerRef,
        "aria-label": accessibilityLabel !== null && accessibilityLabel !== void 0 ? accessibilityLabel : void 0,
        onClick: onClick
    }, value, icon && /* @__PURE__ */ React26.createElement(LodgingEGDSIcon, {
        data: icon
    })));
};
LodgingDialogTriggerMessage.fragment = fragment17;
LodgingDialogTriggerMessage.displayName = "LodgingDialogTriggerMessage";
// ../internal/src/components/property-review-summary/__private/providers/property-filtered-reviews-dialog-provider.tsx
import React27 from "react";
var PropertyFilteredReviewsDialogContext = React27.createContext(void 0);
var usePropertyFilteredReviewsDialogContext = function() {
    var context = React27.useContext(PropertyFilteredReviewsDialogContext);
    if (context === void 0) {
        throw new Error("usePropertyFilteredReviewsDialogContext must be used with a PropertyFilteredReviewsDialogContext.Provider");
    }
    return context;
};
// ../internal/src/components/property-review-summary/__private/__fragments/property-filtered-reviews-dialog.tsx
var fragment18 = gql27(_templateObject29(), LodgingDialogTriggerMessage.fragment, EGDSDialogToolbar.fragment);
var PropertyFilteredReviewsDialog = function(param) {
    var _param_data = param.data, ratingPercentage = _param_data.ratingPercentage, trigger = _param_data.trigger;
    var PropertyFilteredReviewsDialogContent = usePropertyFilteredReviewsDialogContext().PropertyFilteredReviewsDialogContent;
    var _useDialog3 = _slicedToArray(useDialog3("PropertyDetailsReviewsBreakdownDialog", "pwaDialogNested"), 3), isVisible = _useDialog3[0], _useDialog3_ = _useDialog3[1], openDialog = _useDialog3_.openDialog, closeDialog = _useDialog3_.closeDialog, ReviewsDialog = _useDialog3[2];
    var track = useClickTracker11();
    var memoizedCloseDialog = React28.useCallback(function() {
        if (ratingPercentage.closeAnalytics) {
            var closeAnalytics = ratingPercentage.closeAnalytics;
            track(closeAnalytics.referrerId, closeAnalytics.linkName);
        }
        closeDialog();
    }, [
        closeDialog,
        ratingPercentage,
        track
    ]);
    return /* @__PURE__ */ React28.createElement(React28.Fragment, null, /* @__PURE__ */ React28.createElement(LodgingDialogTriggerMessage, {
        onClickAction: openDialog,
        data: trigger
    }), /* @__PURE__ */ React28.createElement(ReviewsDialog, null, /* @__PURE__ */ React28.createElement(UitkSheet2, {
        type: "full",
        isVisible: isVisible,
        triggerRef: null,
        returnFocusOnClose: true
    }, /* @__PURE__ */ React28.createElement(EGDSDialogToolbar, {
        toolbarType: "close",
        toolbarAction: memoizedCloseDialog,
        data: ratingPercentage.toolbar
    }), /* @__PURE__ */ React28.createElement(UitkDialogContent2, null, /* @__PURE__ */ React28.createElement(PropertyFilteredReviewsDialogContent, null)))));
};
PropertyFilteredReviewsDialog.displayName = "PropertyFilteredReviewsDialog";
PropertyFilteredReviewsDialog.fragment = fragment18;
// ../internal/src/components/property-review-summary/review-disclaimer.tsx
import React29, { useState as useState4 } from "react";
import { gql as gql28 } from "@apollo/client";
import { useClickTracker as useClickTracker12 } from "@shared-ui/clickstream-analytics-context";
import { Experiment, ExperimentControl, ExperimentVariant } from "@shared-ui/experiment-context";
import { UitkIcon as UitkIcon8, UitkIconSize as UitkIconSize7 } from "uitk-react-icons";
import { UitkLink as UitkLink6 } from "uitk-react-link";
import { PositionType, UitkMenu, UitkMenuContainer, UitkMenuTrigger } from "uitk-react-menu";
import { UitkSpacing as UitkSpacing17 } from "uitk-react-spacing";
import { UitkParagraph, UitkText as UitkText16 } from "uitk-react-text";
var fragment19 = gql28(_templateObject30());
var ReviewDisclaimer = function(param) {
    var reviewPage = param.reviewPage, data = param.data;
    var _React29_useState = _slicedToArray(React29.useState(false), 2), showMenu = _React29_useState[0], setShowMenu = _React29_useState[1];
    var reviewDisclaimer = data.reviewDisclaimer, reviewDisclaimerAccessibilityLabel = data.reviewDisclaimerAccessibilityLabel, reviewDisclaimerLabel = data.reviewDisclaimerLabel, reviewDisclaimerUrl = data.reviewDisclaimerUrl, reviewDisclaimerAnalytics = data.reviewDisclaimerAnalytics;
    var _useState4 = _slicedToArray(useState4(false), 2), isVerifyReviewsAccordionOpen = _useState4[0], setIsVerifyReviewsAccordionOpen = _useState4[1];
    var clickTracker = useClickTracker12();
    if (!reviewDisclaimer || reviewDisclaimer.length === 0) {
        return null;
    }
    var handleReviewDisclaimerLabelClick = function() {
        if (!showMenu && reviewDisclaimerAnalytics && reviewPage) {
            clickTracker(reviewDisclaimerAnalytics.referrerId, reviewDisclaimerAnalytics.linkName);
        }
        setShowMenu(!showMenu);
    };
    var renderReviewDisclaimerVrbexGeneric = function() {
        return (reviewDisclaimer === null || reviewDisclaimer === void 0 ? void 0 : reviewDisclaimer.length) && reviewDisclaimerLabel === null && /* @__PURE__ */ React29.createElement(React29.Fragment, null, /* @__PURE__ */ React29.createElement(UitkSpacing17, {
            padding: {
                blockstart: "four",
                blockend: "two"
            }
        }, /* @__PURE__ */ React29.createElement(UitkText16, {
            weight: "regular",
            size: 200
        }, reviewDisclaimer)), /* @__PURE__ */ React29.createElement(UitkSpacing17, {
            padding: {
                blockend: "four"
            }
        }, reviewDisclaimerUrl && /* @__PURE__ */ React29.createElement(UitkLink6, null, /* @__PURE__ */ React29.createElement("a", {
            href: reviewDisclaimerUrl.link.url,
            target: "_blank",
            rel: "noreferrer noopener"
        }, reviewDisclaimerUrl.value, /* @__PURE__ */ React29.createElement("span", {
            className: "is-visually-hidden"
        }, reviewDisclaimerUrl.accessibilityLabel)))));
    };
    var reviewsDisclaimerView = (reviewDisclaimer === null || reviewDisclaimer === void 0 ? void 0 : reviewDisclaimer.length) && reviewDisclaimerLabel;
    return /* @__PURE__ */ React29.createElement(React29.Fragment, null, reviewsDisclaimerView && /* @__PURE__ */ React29.createElement(UitkMenu, {
        isOpen: showMenu,
        onTriggerClick: handleReviewDisclaimerLabelClick
    }, /* @__PURE__ */ React29.createElement(UitkMenuTrigger, null, /* @__PURE__ */ React29.createElement(UitkLink6, null, /* @__PURE__ */ React29.createElement("button", {
        type: "button",
        "aria-label": reviewDisclaimerAccessibilityLabel !== null && reviewDisclaimerAccessibilityLabel !== void 0 ? reviewDisclaimerAccessibilityLabel : void 0
    }, reviewDisclaimerLabel, /* @__PURE__ */ React29.createElement(UitkSpacing17, {
        padding: {
            inline: "one",
            block: "half"
        }
    }, /* @__PURE__ */ React29.createElement(UitkIcon8, {
        name: "info_outline",
        size: UitkIconSize7.SMALL
    }))))), /* @__PURE__ */ React29.createElement(UitkMenuContainer, {
        autoPosition: true,
        position: PositionType.LEFT,
        width: 300
    }, /* @__PURE__ */ React29.createElement(UitkSpacing17, {
        padding: {
            inline: "four"
        }
    }, /* @__PURE__ */ React29.createElement(UitkParagraph, {
        size: 1
    }, reviewDisclaimer, reviewDisclaimerUrl && /* @__PURE__ */ React29.createElement(UitkLink6, null, /* @__PURE__ */ React29.createElement("a", {
        href: reviewDisclaimerUrl.link.url,
        target: "_blank",
        rel: "noreferrer noopener"
    }, reviewDisclaimerUrl.value, /* @__PURE__ */ React29.createElement("span", {
        className: "is-visually-hidden"
    }, reviewDisclaimerUrl.accessibilityLabel))))))), /* @__PURE__ */ React29.createElement(Experiment, {
        name: "Vrbex_generic"
    }, /* @__PURE__ */ React29.createElement(ExperimentControl, null), /* @__PURE__ */ React29.createElement(ExperimentVariant, {
        bucket: 1
    }, renderReviewDisclaimerVrbexGeneric())));
};
ReviewDisclaimer.displayName = "ReviewDisclaimer";
ReviewDisclaimer.fragment = fragment19;
// ../internal/src/components/property-review-summary/property-reviews-breakdown.tsx
var fragment20 = gql29(_templateObject31(), ReviewDisclaimer.fragment, SummaryDetails.fragment, RatingCounts.fragment, PropertyFilteredReviewsDialog.fragment);
var PropertyReviewsBreakdown = function(param) {
    var data = param.data, onClickLink = param.onClickLink, _param_withAggregateRating = param.withAggregateRating, withAggregateRating = _param_withAggregateRating === void 0 ? false : _param_withAggregateRating, reviewPage = param.reviewPage;
    var averageOverallRating = data.averageOverallRating, superlative = data.superlative, propertyReviewCountDetails = data.propertyReviewCountDetails, reviewDisclaimer = data.reviewDisclaimer, totalCount = data.totalCount, seeAllAction = data.seeAllAction, reviewDisclaimerLabel = data.reviewDisclaimerLabel;
    var renderPropertyReviewBreakdownVrbexGeneric = function() {
        return totalCount.raw !== 0 && (reviewDisclaimer === null || reviewDisclaimer === void 0 ? void 0 : reviewDisclaimer.length) && reviewDisclaimerLabel === null && /* @__PURE__ */ React30.createElement(UitkLayoutFlexItem7, {
            minWidth: "full_width"
        }, /* @__PURE__ */ React30.createElement(ReviewDisclaimer, {
            data: data,
            reviewPage: reviewPage
        }));
    };
    var reviewsDisclaimerView = (reviewDisclaimer === null || reviewDisclaimer === void 0 ? void 0 : reviewDisclaimer.length) && reviewDisclaimerLabel;
    return /* @__PURE__ */ React30.createElement("div", _objectSpread({}, getStructuredDataProps("aggregateRating", withAggregateRating)), totalCount.raw !== 0 && /* @__PURE__ */ React30.createElement(UitkLayoutFlex8, {
        space: "three"
    }, /* @__PURE__ */ React30.createElement(UitkText17, {
        weight: "regular",
        size: 900
    }, /* @__PURE__ */ React30.createElement("span", _objectSpread({}, getStructuredDataProps("ratingValue", withAggregateRating)), averageOverallRating.formatted)), /* @__PURE__ */ React30.createElement(UitkSpacing18, {
        padding: {
            blockstart: "one"
        }
    }, /* @__PURE__ */ React30.createElement(UitkLayoutFlex8, {
        direction: "column"
    }, /* @__PURE__ */ React30.createElement(UitkHeading8, {
        tag: "h3",
        size: 6
    }, superlative), /* @__PURE__ */ React30.createElement(UitkLayoutFlex8, null, /* @__PURE__ */ React30.createElement(UitkSpacing18, {
        padding: {
            block: "two"
        }
    }, seeAllAction ? /* @__PURE__ */ React30.createElement(PropertyFilteredReviewsDialog, {
        data: seeAllAction
    }) : /* @__PURE__ */ React30.createElement(UitkLink7, {
        onClick: onClickLink,
        size: "medium"
    }, /* @__PURE__ */ React30.createElement("button", _objectSpread({
        type: "button"
    }, getStructuredDataProps("reviewCount", withAggregateRating)), propertyReviewCountDetails === null || propertyReviewCountDetails === void 0 ? void 0 : propertyReviewCountDetails.shortDescription)))), reviewsDisclaimerView && /* @__PURE__ */ React30.createElement(UitkLayoutFlexItem7, null, /* @__PURE__ */ React30.createElement(ReviewDisclaimer, {
        data: data,
        reviewPage: reviewPage
    }))))), /* @__PURE__ */ React30.createElement(Experiment2, {
        name: "Vrbex_generic"
    }, /* @__PURE__ */ React30.createElement(ExperimentControl2, null), /* @__PURE__ */ React30.createElement(ExperimentVariant2, {
        bucket: 1
    }, renderPropertyReviewBreakdownVrbexGeneric())), /* @__PURE__ */ React30.createElement(RatingCounts, {
        data: data
    }), /* @__PURE__ */ React30.createElement(SummaryDetails, {
        data: data
    }));
};
PropertyReviewsBreakdown.displayName = "PropertyReviewsBreakdownFragment";
PropertyReviewsBreakdown.fragment = fragment20;
// src/components/__private/__fragments/property-reviews-summary-fragment.tsx
import { UitkLayoutFlex as UitkLayoutFlex9 } from "uitk-react-layout-flex";
import { UitkProgressBar as UitkProgressBar2 } from "uitk-react-progress-bar";
import { UitkSpacing as UitkSpacing19 } from "uitk-react-spacing";
import { UitkText as UitkText18 } from "uitk-react-text";
var fragment21 = gql30(_templateObject32(), ReviewDisclaimer.fragment, LodgingEnrichedMessage.fragment);
var PropertyReviewsSummaryFragment = function(param) {
    var data = param.data, _param_withAggregateRating = param.withAggregateRating, withAggregateRating = _param_withAggregateRating === void 0 ? false : _param_withAggregateRating, reviewPage = param.reviewPage;
    var overallScoreWithDescriptionA11y = data.overallScoreWithDescriptionA11y, propertyReviewCountDetails = data.propertyReviewCountDetails, reviewSummaryDetails = data.reviewSummaryDetails, totalCount = data.totalCount;
    return /* @__PURE__ */ React31.createElement(UitkSpacing19, {
        margin: {
            blockend: "six"
        }
    }, /* @__PURE__ */ React31.createElement("div", _objectSpread({
        "data-stid": "property-reviews-summary"
    }, getStructuredDataProps("aggregateRating", withAggregateRating)), overallScoreWithDescriptionA11y && /* @__PURE__ */ React31.createElement(LodgingEnrichedMessage, {
        data: overallScoreWithDescriptionA11y,
        textSize: 400
    }), /* @__PURE__ */ React31.createElement("span", _objectSpread({
        className: "is-visually-hidden",
        "aria-hidden": "true"
    }, getStructuredDataProps("reviewCount", withAggregateRating)), totalCount === null || totalCount === void 0 ? void 0 : totalCount.raw), /* @__PURE__ */ React31.createElement(UitkText18, {
        size: 300,
        spacing: "one"
    }, propertyReviewCountDetails === null || propertyReviewCountDetails === void 0 ? void 0 : propertyReviewCountDetails.fullDescription), /* @__PURE__ */ React31.createElement(ReviewDisclaimer, {
        data: data,
        reviewPage: reviewPage
    }), reviewSummaryDetails && reviewSummaryDetails.length > 0 && /* @__PURE__ */ React31.createElement(UitkLayoutFlex9, {
        direction: "column",
        space: "two"
    }, reviewSummaryDetails.map(function(reviewSummaryDetailItem) {
        /* @__PURE__ */ return React31.createElement(UitkSpacing19, {
            padding: {
                blockstart: "two"
            },
            key: "category-".concat(reviewSummaryDetailItem === null || reviewSummaryDetailItem === void 0 ? void 0 : reviewSummaryDetailItem.label)
        }, /* @__PURE__ */ React31.createElement("div", null, /* @__PURE__ */ React31.createElement(UitkProgressBar2, {
            percent: reviewSummaryDetailItem === null || reviewSummaryDetailItem === void 0 ? void 0 : reviewSummaryDetailItem.ratingPercentage,
            progressDescription: reviewSummaryDetailItem === null || reviewSummaryDetailItem === void 0 ? void 0 : reviewSummaryDetailItem.formattedRatingOutOfMax,
            title: reviewSummaryDetailItem === null || reviewSummaryDetailItem === void 0 ? void 0 : reviewSummaryDetailItem.label
        })));
    }))));
};
PropertyReviewsSummaryFragment.displayName = "PropertyReviewsSummaryFragment";
PropertyReviewsSummaryFragment.fragment = fragment21;
var property_reviews_summary_fragment_default = PropertyReviewsSummaryFragment;
// src/components/property-reviews-summary.tsx
var __PropertyReviewSummariesQuery = gql31(_templateObject33(), property_reviews_summary_fragment_default.fragment);
var PropertyReviewsSummary = function(param) {
    var propertyId = param.inputs.propertyId, _param_withAggregateRating = param.withAggregateRating, withAggregateRating = _param_withAggregateRating === void 0 ? false : _param_withAggregateRating;
    var context = useBexApi6().context;
    var variables = {
        context: context,
        propertyIds: propertyId ? [
            propertyId
        ] : []
    };
    var _useQuery3 = useQuery3(__PropertyReviewSummariesQuery, {
        variables: variables,
        errorPolicy: "all",
        fetchPolicy: "cache-first"
    }), data = _useQuery3.data, error = _useQuery3.error, loading = _useQuery3.loading;
    if (loading || error || !(data === null || data === void 0 ? void 0 : data.propertyReviewSummaries) || data.propertyReviewSummaries.length === 0) {
        return null;
    }
    return /* @__PURE__ */ React32.createElement(property_reviews_summary_fragment_default, {
        withAggregateRating: withAggregateRating,
        data: data.propertyReviewSummaries[0]
    });
};
// src/components/property-reviews-snippets.tsx
import React33 from "react";
import { gql as gql32, useQuery as useQuery4 } from "@apollo/client";
import { UitkLayoutFlex as UitkLayoutFlex10, UitkLayoutFlexItem as UitkLayoutFlexItem8 } from "uitk-react-layout-flex";
import { UitkText as UitkText19 } from "uitk-react-text";
var __PropertyReviewsSnippetsQuery = gql32(_templateObject34());
var PropertyReviewsSnippets = function(param) {
    var _param_inputs = param.inputs, context = _param_inputs.context, propertyId = _param_inputs.propertyId;
    var variables = {
        context: context,
        propertyIds: propertyId
    };
    var _useQuery4 = useQuery4(__PropertyReviewsSnippetsQuery, {
        variables: variables,
        errorPolicy: "all",
        fetchPolicy: "cache-first"
    }), data = _useQuery4.data, error = _useQuery4.error, loading = _useQuery4.loading;
    if (loading || error || !data || !data.propertyReviewAggregates || !data.propertyReviewAggregates.propertySentiment || !data.propertyReviewAggregates.propertySentiment.length) {
        return null;
    }
    var propertySentiments = data.propertyReviewAggregates.propertySentiment;
    return /* @__PURE__ */ React33.createElement(UitkLayoutFlex10, {
        space: "six"
    }, propertySentiments.map(function(propertySentiment, index) {
        return /* @__PURE__ */ React33.createElement(UitkLayoutFlexItem8, {
            key: "review-".concat(index)
        }, /* @__PURE__ */ React33.createElement("div", null, /* @__PURE__ */ React33.createElement(UitkText19, {
            weight: "bold",
            size: 300
        }, propertySentiment.text), /* @__PURE__ */ React33.createElement(UitkText19, {
            size: 300
        }, propertySentiment.subtext)));
    }));
};
// src/components/property-reviews-summary-line.tsx
import React34 from "react";
import { gql as gql33, useQuery as useQuery5 } from "@apollo/client";
import { useBexApi as useBexApi7 } from "@shared-ui/bex-api-context";
import { useClickTracker as useClickTracker13 } from "@shared-ui/clickstream-analytics-context";
import { UitkIcon as UitkIcon9, UitkIconSize as UitkIconSize8 } from "uitk-react-icons";
import { UitkLink as UitkLink8 } from "uitk-react-link";
import { PositionType as PositionType2, UitkMenu as UitkMenu2, UitkMenuContainer as UitkMenuContainer2, UitkMenuTrigger as UitkMenuTrigger2 } from "uitk-react-menu";
import { UitkMoreInfoTrigger } from "uitk-react-more-info-trigger";
import { UitkSpacing as UitkSpacing20 } from "uitk-react-spacing";
var __PropertyReviewSummariesLineQuery = gql33(_templateObject35());
var PropertyReviewsSummaryLine = function(param) {
    var propertyId = param.inputs.propertyId;
    var context = useBexApi7().context;
    var variables = {
        propertyIds: propertyId ? [
            propertyId
        ] : [],
        context: context
    };
    var tracker = useClickTracker13();
    var _React34_useState = _slicedToArray(React34.useState(false), 2), showMenu = _React34_useState[0], setShowMenu = _React34_useState[1];
    var _useQuery5 = useQuery5(__PropertyReviewSummariesLineQuery, {
        variables: variables,
        errorPolicy: "all",
        fetchPolicy: "cache-first"
    }), data = _useQuery5.data, error = _useQuery5.error, loading = _useQuery5.loading;
    if (loading || error) {
        return null;
    }
    if (!data || !data.propertyReviewSummaries || !data.propertyReviewSummaries.length) {
        return null;
    }
    var _data_propertyReviewSummaries_ = data.propertyReviewSummaries[0], overallScoreWithDescription = _data_propertyReviewSummaries_.overallScoreWithDescription, propertyReviewCountDetails = _data_propertyReviewSummaries_.propertyReviewCountDetails, reviewDisclaimer = _data_propertyReviewSummaries_.reviewDisclaimer, reviewDisclaimerAccessibilityLabel = _data_propertyReviewSummaries_.reviewDisclaimerAccessibilityLabel, totalCount = _data_propertyReviewSummaries_.totalCount;
    return /* @__PURE__ */ React34.createElement("div", {
        className: "uitk-layout-flex",
        itemProp: "aggregateRating",
        itemScope: true,
        itemType: "http://schema.org/AggregateRating",
        "data-stid": "property-reviews-summary-line"
    }, overallScoreWithDescription && /* @__PURE__ */ React34.createElement(UitkSpacing20, {
        margin: {
            inlineend: "one"
        }
    }, /* @__PURE__ */ React34.createElement("span", {
        itemProp: "ratingValue",
        className: "uitk-type-bold"
    }, overallScoreWithDescription)), totalCount && /* @__PURE__ */ React34.createElement("span", {
        "aria-hidden": true,
        className: "is-visually-hidden",
        itemProp: "reviewCount"
    }, totalCount.raw), propertyReviewCountDetails && /* @__PURE__ */ React34.createElement("span", null, propertyReviewCountDetails.fullDescription), /* @__PURE__ */ React34.createElement(UitkMenu2, {
        isOpen: showMenu,
        onTriggerClick: function() {
            tracker(DISCLAIMER_DIALOG_TRACKER.rfrr, DISCLAIMER_DIALOG_TRACKER.link);
            setShowMenu(!showMenu);
        }
    }, /* @__PURE__ */ React34.createElement(UitkMenuTrigger2, null, /* @__PURE__ */ React34.createElement(UitkLink8, {
        inline: true
    }, /* @__PURE__ */ React34.createElement(UitkMoreInfoTrigger, null, /* @__PURE__ */ React34.createElement("button", {
        type: "button"
    }, /* @__PURE__ */ React34.createElement(UitkIcon9, {
        name: "info_outline",
        id: "property-reviews-summary-disclaimer",
        size: UitkIconSize8.EXTRA_SMALL,
        title: reviewDisclaimerAccessibilityLabel || void 0
    }))))), /* @__PURE__ */ React34.createElement(UitkMenuContainer2, {
        position: PositionType2.RIGHT,
        width: 300
    }, /* @__PURE__ */ React34.createElement(UitkSpacing20, {
        padding: {
            inline: "four"
        }
    }, /* @__PURE__ */ React34.createElement("p", {
        "data-stid": "review-disclaimer"
    }, reviewDisclaimer)))));
};
// src/components/property-reviews-breakdown.tsx
import React39 from "react";
import { gql as gql38, useQuery as useQuery7 } from "@apollo/client";
import { useBexApi as useBexApi9 } from "@shared-ui/bex-api-context";
import { UitkSpacing as UitkSpacing23 } from "uitk-react-spacing";
// src/components/property-filtered-reviews.tsx
import React38 from "react";
import { gql as gql37, useQuery as useQuery6 } from "@apollo/client";
import { useBexApi as useBexApi8 } from "@shared-ui/bex-api-context";
import { Experiment as Experiment3, ExperimentControl as ExperimentControl3, ExperimentVariant as ExperimentVariant3 } from "@shared-ui/experiment-context";
import { ViewExtraLarge, ViewLarge, ViewMedium as ViewMedium2, Viewport as Viewport2, ViewSmall as ViewSmall2 } from "@shared-ui/viewport-context";
import { UitkLayoutFlex as UitkLayoutFlex12, UitkLayoutFlexItem as UitkLayoutFlexItem10 } from "uitk-react-layout-flex";
import { UitkLayoutGrid as UitkLayoutGrid3, UitkLayoutGridItem as UitkLayoutGridItem3 } from "uitk-react-layout-grid";
import { UitkLoader } from "uitk-react-loader";
import { UitkSpacing as UitkSpacing22 } from "uitk-react-spacing";
// src/components/__private/__fragments/search-box.tsx
import React35, { useMemo } from "react";
import { gql as gql34 } from "@apollo/client";
import { useEgClickstream } from "@shared-ui/clickstream-analytics-context";
import { ViewMedium, Viewport, ViewSmall } from "@shared-ui/viewport-context";
import { UitkButtonSize as UitkButtonSize2, UitkPrimaryButton as UitkPrimaryButton2 } from "uitk-react-button";
import { UitkForm } from "uitk-react-form";
import { UitkIcon as UitkIcon10 } from "uitk-react-icons";
import { UitkTextInput } from "uitk-react-input";
import { UitkLayoutFlex as UitkLayoutFlex11, UitkLayoutFlexItem as UitkLayoutFlexItem9 } from "uitk-react-layout-flex";
var fragment22 = gql34(_templateObject36());
var SearchBox = function(param) {
    var data = param.data, setSearchInputVal = param.setSearchInputVal, searchInputVal = param.searchInputVal, resetFilters = param.resetFilters;
    var _React35_useState = _slicedToArray(React35.useState(searchInputVal), 2), inputVal = _React35_useState[0], setInputVal = _React35_useState[1];
    var searchData = data.sortAndFilter.find(function(o) {
        return o.name === "reviewsSearch";
    });
    var trackEvent = useEgClickstream();
    var trackSearchInitiate = function() {
        return trackEvent(reviewSearchInitiatedEvent());
    };
    useMemo(function() {
        setInputVal(searchInputVal);
    }, [
        searchInputVal
    ]);
    if (!searchData || !searchData.label || !searchData.name || !searchData.graphic) {
        return null;
    }
    var label = searchData.label, name = searchData.name, graphic = searchData.graphic;
    var iconId = graphic.id, buttonTitle = graphic.description, iconToken = graphic.token;
    if (!iconId || !buttonTitle || !iconToken) {
        return null;
    }
    var handleChange = function(event) {
        var value = event.target.value;
        setInputVal(value);
    };
    var handleSubmit = function(event) {
        event.preventDefault();
        setSearchInputVal(inputVal);
        resetFilters === null || resetFilters === void 0 ? void 0 : resetFilters("search");
        trackEvent(reviewSearchSubmittedEvent());
    };
    var searchBox = /* @__PURE__ */ React35.createElement(React35.Fragment, null, /* @__PURE__ */ React35.createElement(UitkLayoutFlexItem9, null, /* @__PURE__ */ React35.createElement(UitkTextInput, {
        size: 300,
        id: "search-input-box",
        label: label,
        name: name,
        value: inputVal,
        onChange: handleChange,
        hasClearButton: true,
        onClick: trackSearchInitiate
    })), /* @__PURE__ */ React35.createElement(UitkLayoutFlexItem9, null, /* @__PURE__ */ React35.createElement(UitkPrimaryButton2, {
        size: UitkButtonSize2.LARGE,
        type: "submit",
        name: buttonTitle,
        title: buttonTitle,
        id: "search-btn",
        "aria-label": buttonTitle,
        disabled: (inputVal === null || inputVal === void 0 ? void 0 : inputVal.length) === 0
    }, /* @__PURE__ */ React35.createElement(UitkIcon10, {
        name: iconToken,
        id: iconId
    }))));
    return /* @__PURE__ */ React35.createElement(Viewport, null, /* @__PURE__ */ React35.createElement(ViewSmall, null, /* @__PURE__ */ React35.createElement(UitkForm, {
        onSubmit: handleSubmit
    }, /* @__PURE__ */ React35.createElement(UitkLayoutFlex11, {
        space: "four"
    }, searchBox))), /* @__PURE__ */ React35.createElement(ViewMedium, null, /* @__PURE__ */ React35.createElement(UitkForm, {
        onSubmit: handleSubmit
    }, /* @__PURE__ */ React35.createElement(UitkLayoutFlex11, {
        space: "two"
    }, searchBox))));
};
SearchBox.fragment = fragment22;
SearchBox.displayName = "SearchBox";
var search_box_default = SearchBox;
// src/components/__private/__fragments/sort-type.tsx
import React36, { useMemo as useMemo2 } from "react";
import { gql as gql35 } from "@apollo/client";
import { useClickTracker as useClickTracker14 } from "@shared-ui/clickstream-analytics-context";
import { UitkSelect } from "uitk-react-input";
var fragment23 = gql35(_templateObject37());
var SortType = function(param) {
    var data = param.data, setSortType = param.setSortType, resetFilters = param.resetFilters;
    var sortRating = data.sortAndFilter.find(function(o) {
        return o.name === "sortBy";
    });
    var _React36_useState = _slicedToArray(React36.useState((sortRating === null || sortRating === void 0 ? void 0 : sortRating.options[0].optionValue) || ""), 2), selectedVal = _React36_useState[0], setSelectedVal = _React36_useState[1];
    var tracker = useClickTracker14();
    useMemo2(function() {
        var selectedOption = sortRating === null || sortRating === void 0 ? void 0 : sortRating.options.find(function(o) {
            return o.isSelected === true;
        });
        setSelectedVal((selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.optionValue) || "");
    }, [
        sortRating
    ]);
    if (!sortRating || !sortRating.options || !sortRating.label || sortRating.options.length === 0) {
        return null;
    }
    var name = sortRating.name, label = sortRating.label, options = sortRating.options;
    var onChangeHandler = function(event) {
        var selectedIndex = event.target.options.selectedIndex;
        var _options_selectedIndex = options[selectedIndex], clickAnalytics2 = _options_selectedIndex.clickAnalytics;
        var _ref = clickAnalytics2 || {}, referrerId = _ref.referrerId, linkName = _ref.linkName;
        if (referrerId && linkName) {
            tracker(referrerId, linkName);
        }
        setSelectedVal(event.currentTarget.value);
        setSortType(event.currentTarget.value);
        resetFilters === null || resetFilters === void 0 ? void 0 : resetFilters("sortBy");
    };
    var clickAnalytics = sortRating.clickAnalytics;
    var onClickHandler = function() {
        var _ref = clickAnalytics || {}, referrerId = _ref.referrerId, linkName = _ref.linkName;
        if (referrerId && linkName) {
            tracker(referrerId, linkName);
        }
    };
    return /* @__PURE__ */ React36.createElement(UitkSelect, {
        id: name,
        value: selectedVal,
        label: label,
        name: name,
        emptyState: false,
        onChange: onChangeHandler,
        onClick: onClickHandler
    }, /* @__PURE__ */ React36.createElement(React36.Fragment, null, options.map(function(option, index) {
        if (option.optionValue && option.label) {
            return /* @__PURE__ */ React36.createElement("option", {
                key: index,
                value: option.optionValue,
                label: option.label,
                "aria-selected": option.isSelected
            }, option.label);
        }
        return null;
    })));
};
SortType.displayName = "SortType";
SortType.fragment = fragment23;
var sort_type_default = SortType;
// src/components/__private/__fragments/traveler-type.tsx
import React37 from "react";
import { gql as gql36 } from "@apollo/client";
import { useClickTracker as useClickTracker15 } from "@shared-ui/clickstream-analytics-context";
import { UitkCheckbox as UitkCheckbox2, UitkCheckboxGroup } from "uitk-react-checkbox";
import { UitkSpacing as UitkSpacing21 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading9 } from "uitk-react-text";
var fragment24 = gql36(_templateObject38());
var TravelerType = function(param) {
    var data = param.data, setTravelerType = param.setTravelerType, selectedTravelerTypes = param.selectedTravelerTypes, resetFilters = param.resetFilters;
    var travelerType = data.sortAndFilter.find(function(o) {
        return o.name === "travelerType";
    });
    var selectionMap = {};
    var tracker = useClickTracker15();
    if (!travelerType || !travelerType.options || travelerType.options.length === 0) {
        return null;
    }
    var name = travelerType.name, label = travelerType.label, options = travelerType.options;
    var toggleSelection = function(optionValue, referrerId, linkName) {
        return function() {
            if (referrerId && linkName) {
                tracker(referrerId, linkName);
            }
            selectionMap[optionValue] = !selectionMap[optionValue];
            setTravelerType(Object.keys(selectionMap).filter(function(option) {
                return !!selectionMap[option];
            }));
            resetFilters === null || resetFilters === void 0 ? void 0 : resetFilters("travelerType");
        };
    };
    return /* @__PURE__ */ React37.createElement(React37.Fragment, null, /* @__PURE__ */ React37.createElement(UitkSpacing21, {
        padding: {
            blockend: "two"
        }
    }, /* @__PURE__ */ React37.createElement(UitkHeading9, {
        size: 5,
        tag: "h4"
    }, label)), /* @__PURE__ */ React37.createElement(UitkCheckboxGroup, {
        legendLabel: label !== null && label !== void 0 ? label : void 0,
        group: "traveler-type"
    }, options.filter(function(option) {
        return option.optionValue;
    }).map(function(option) {
        var optionValue = option.optionValue, description = option.description, clickAnalytics = option.clickAnalytics;
        selectionMap[optionValue] = selectedTravelerTypes.includes(optionValue);
        return /* @__PURE__ */ React37.createElement(UitkCheckbox2, {
            key: "".concat(name, "-").concat(optionValue),
            id: "".concat(name, "-").concat(optionValue),
            value: optionValue,
            checked: selectionMap[optionValue],
            description: description || "",
            onChange: toggleSelection(optionValue, clickAnalytics === null || clickAnalytics === void 0 ? void 0 : clickAnalytics.referrerId, clickAnalytics === null || clickAnalytics === void 0 ? void 0 : clickAnalytics.linkName)
        }, option.label || "");
    })));
};
TravelerType.displayName = "TravelerType";
TravelerType.fragment = fragment24;
var traveler_type_default = TravelerType;
// src/components/property-filtered-reviews.tsx
var __PropertyFilteredReviewsQuery = gql37(_templateObject39(), property_reviews_summary_fragment_default.fragment, PropertyReviewsListFragment, traveler_type_default.fragment, sort_type_default.fragment, search_box_default.fragment);
var PropertyFilteredReviews = function(param) {
    var _param_inputs = param.inputs, propertyId = _param_inputs.propertyId, pagination = _param_inputs.pagination, includeRecentReviews = _param_inputs.includeRecentReviews, searchCriteria = _param_inputs.searchCriteria;
    var context = useBexApi8().context;
    var size = (pagination === null || pagination === void 0 ? void 0 : pagination.size) || DEFAULT_PAGINATION_SIZE;
    var startingIndex = (pagination === null || pagination === void 0 ? void 0 : pagination.startingIndex) || DEFAULT_STARTING_INDEX;
    var _React38_useState = _slicedToArray(React38.useState([]), 2), travelerType = _React38_useState[0], setTravelerType = _React38_useState[1];
    var _React38_useState1 = _slicedToArray(React38.useState(DEFAULT_REVIEWS_SORT), 2), sortRating = _React38_useState1[0], setSortType = _React38_useState1[1];
    var _React38_useState2 = _slicedToArray(React38.useState(DEFAULT_SEARCH_INPUT), 2), searchInputVal = _React38_useState2[0], setSearchInputVal = _React38_useState2[1];
    var variables = {
        context: context,
        propertyId: propertyId,
        searchCriteria: {
            primary: searchCriteria.primary,
            secondary: {
                booleans: [
                    {
                        id: "includeRecentReviews",
                        value: includeRecentReviews !== null && includeRecentReviews !== void 0 ? includeRecentReviews : true
                    },
                    {
                        id: "includeRatingsOnlyReviews",
                        value: true
                    },
                    {
                        id: "overrideEmbargoForIndividualReviews",
                        value: true
                    }
                ],
                counts: [
                    {
                        id: "startIndex",
                        value: startingIndex
                    },
                    {
                        id: "size",
                        value: size
                    }
                ],
                selections: _toConsumableArray(travelerType.map(function(value) {
                    return {
                        id: "travelerType",
                        value: value
                    };
                })).concat([
                    {
                        id: "sortBy",
                        value: sortRating
                    },
                    {
                        id: "searchTerm",
                        value: searchInputVal
                    }
                ])
            }
        }
    };
    var resetFilters = function(type) {
        switch(type){
            case "search":
                setTravelerType([]);
                setSortType(DEFAULT_REVIEWS_SORT);
                break;
            case "travelerType":
            case "sortBy":
                setSearchInputVal(DEFAULT_SEARCH_INPUT);
                break;
            default:
                setTravelerType([]);
                setSortType(DEFAULT_REVIEWS_SORT);
                setSearchInputVal(DEFAULT_SEARCH_INPUT);
        }
    };
    var _useQuery6 = useQuery6(__PropertyFilteredReviewsQuery, {
        variables: variables,
        errorPolicy: "all",
        fetchPolicy: "cache-first"
    }), currentData = _useQuery6.data, previousData = _useQuery6.previousData, error = _useQuery6.error, loading = _useQuery6.loading, fetchMore = _useQuery6.fetchMore;
    var paginationFetch = buildFetchMoreReviews(fetchMore, variables);
    var data = currentData !== null && currentData !== void 0 ? currentData : previousData;
    if (error || loading && !data || !data) {
        return null;
    }
    var reviewInfo = data.propertyInfo.reviewInfo;
    var reviewsContent = null;
    if (loading) {
        reviewsContent = /* @__PURE__ */ React38.createElement(UitkLayoutFlex12, {
            justifyContent: "center"
        }, /* @__PURE__ */ React38.createElement(UitkLoader, null));
    } else {
        reviewsContent = /* @__PURE__ */ React38.createElement("div", {
            "data-stid": "property-reviews-list"
        }, /* @__PURE__ */ React38.createElement(property_reviews_list_default, {
            propertyId: propertyId,
            size: size,
            data: reviewInfo,
            fetchMore: paginationFetch,
            reviewsPage: "ReviewsOverlay" /* REVIEWS_OVERLAY */ ,
            showLoadMoreCTA: !searchInputVal
        }));
    }
    var sortComponent = /* @__PURE__ */ React38.createElement("div", {
        "data-stid": "property-reviews-sort"
    }, /* @__PURE__ */ React38.createElement(sort_type_default, {
        selectedSortTypes: sortRating,
        setSortType: setSortType,
        data: reviewInfo.sortAndFilter,
        resetFilters: resetFilters
    }));
    var searchComponent = /* @__PURE__ */ React38.createElement("div", {
        "data-stid": "property-reviews-search"
    }, /* @__PURE__ */ React38.createElement(search_box_default, {
        data: reviewInfo.sortAndFilter,
        setSearchInputVal: setSearchInputVal,
        searchInputVal: searchInputVal,
        resetFilters: resetFilters
    }));
    return /* @__PURE__ */ React38.createElement(UitkSpacing22, {
        padding: {
            large: {
                blockstart: "four",
                inline: "twelve"
            },
            extra_large: {
                blockstart: "four",
                inline: "twelve"
            }
        }
    }, /* @__PURE__ */ React38.createElement(UitkLayoutGrid3, {
        columns: {
            small: 1,
            medium: 1,
            large: 3
        },
        space: "six"
    }, /* @__PURE__ */ React38.createElement(UitkSpacing22, {
        padding: {
            large: {
                inlinestart: "six"
            },
            extra_large: {
                inlinestart: "twelve"
            }
        }
    }, /* @__PURE__ */ React38.createElement(UitkLayoutGridItem3, {
        colSpan: {
            small: 1,
            medium: 1,
            large: 1
        }
    }, /* @__PURE__ */ React38.createElement("div", null, !!data.propertyReviewSummaries.length && /* @__PURE__ */ React38.createElement(property_reviews_summary_fragment_default, {
        data: data.propertyReviewSummaries[0],
        reviewPage: "ReviewsOverlay" /* REVIEWS_OVERLAY */ .valueOf()
    }), /* @__PURE__ */ React38.createElement(traveler_type_default, {
        selectedTravelerTypes: travelerType,
        setTravelerType: setTravelerType,
        data: reviewInfo.sortAndFilter,
        resetFilters: resetFilters
    })))), /* @__PURE__ */ React38.createElement(Experiment3, {
        name: "Free_text_search_of_reviews_in_reviews_overlay"
    }, /* @__PURE__ */ React38.createElement(ExperimentControl3, null, /* @__PURE__ */ React38.createElement(UitkLayoutGridItem3, {
        colSpan: {
            small: 1,
            medium: 1,
            large: 2,
            extra_large: 2
        }
    }, /* @__PURE__ */ React38.createElement(UitkLayoutGrid3, {
        columns: {
            small: 1,
            medium: 1,
            large: 1
        }
    }, /* @__PURE__ */ React38.createElement(Viewport2, null, /* @__PURE__ */ React38.createElement(ViewSmall2, null, /* @__PURE__ */ React38.createElement(UitkSpacing22, {
        padding: {
            small: {
                blockend: "four"
            }
        }
    }, /* @__PURE__ */ React38.createElement(UitkLayoutGridItem3, null, /* @__PURE__ */ React38.createElement(UitkLayoutFlex12, {
        direction: "row-reverse"
    }, /* @__PURE__ */ React38.createElement(UitkLayoutFlexItem10, {
        minWidth: "full_width"
    }, sortComponent))))), /* @__PURE__ */ React38.createElement(ViewMedium2, null, /* @__PURE__ */ React38.createElement(UitkSpacing22, {
        padding: {
            small: {
                blockend: "four"
            }
        }
    }, /* @__PURE__ */ React38.createElement(UitkLayoutGridItem3, null, /* @__PURE__ */ React38.createElement(UitkLayoutFlex12, {
        direction: "row"
    }, /* @__PURE__ */ React38.createElement(UitkLayoutFlexItem10, {
        minWidth: 205
    }, sortComponent))))), /* @__PURE__ */ React38.createElement(ViewLarge, null, /* @__PURE__ */ React38.createElement(UitkSpacing22, {
        padding: {
            medium: {
                inlineend: "six",
                blockend: "four"
            }
        }
    }, /* @__PURE__ */ React38.createElement(UitkLayoutGridItem3, {
        colStart: 2
    }, /* @__PURE__ */ React38.createElement(UitkLayoutFlex12, {
        direction: "row-reverse"
    }, /* @__PURE__ */ React38.createElement(UitkLayoutFlexItem10, {
        minWidth: 205
    }, sortComponent))))), /* @__PURE__ */ React38.createElement(ViewExtraLarge, null, /* @__PURE__ */ React38.createElement(UitkSpacing22, {
        padding: {
            extra_large: {
                inlineend: "twelve",
                blockend: "six"
            }
        }
    }, /* @__PURE__ */ React38.createElement(UitkLayoutGridItem3, {
        colStart: 2
    }, /* @__PURE__ */ React38.createElement(UitkLayoutFlex12, {
        direction: "row-reverse"
    }, /* @__PURE__ */ React38.createElement(UitkLayoutFlexItem10, {
        minWidth: 205
    }, sortComponent)))))), /* @__PURE__ */ React38.createElement(UitkSpacing22, {
        padding: {
            large: {
                inlineend: "six"
            },
            extra_large: {
                inlineend: "twelve"
            }
        }
    }, /* @__PURE__ */ React38.createElement(UitkLayoutGridItem3, {
        colSpan: {
            small: 1,
            medium: 1,
            large: 2,
            extra_large: 2
        }
    }, reviewsContent))))), /* @__PURE__ */ React38.createElement(ExperimentVariant3, {
        bucket: 1
    }, /* @__PURE__ */ React38.createElement(UitkLayoutGridItem3, {
        colSpan: {
            small: 1,
            medium: 1,
            large: 2,
            extra_large: 2
        }
    }, /* @__PURE__ */ React38.createElement(UitkLayoutGrid3, {
        columns: 1,
        space: "six",
        alignContent: "start"
    }, /* @__PURE__ */ React38.createElement(Viewport2, null, /* @__PURE__ */ React38.createElement(ViewSmall2, null, /* @__PURE__ */ React38.createElement(UitkLayoutGrid3, {
        space: "six",
        columns: {
            small: 1,
            medium: [
                "3fr",
                "1fr"
            ]
        }
    }, /* @__PURE__ */ React38.createElement(UitkLayoutGridItem3, null, searchComponent), /* @__PURE__ */ React38.createElement(UitkLayoutGridItem3, null, sortComponent))), /* @__PURE__ */ React38.createElement(ViewMedium2, null, /* @__PURE__ */ React38.createElement(UitkLayoutGrid3, {
        space: "six",
        columns: {
            small: 1,
            medium: [
                "3fr",
                "1fr"
            ]
        }
    }, /* @__PURE__ */ React38.createElement(UitkLayoutGridItem3, null, searchComponent), /* @__PURE__ */ React38.createElement(UitkLayoutGridItem3, null, sortComponent))), /* @__PURE__ */ React38.createElement(ViewLarge, null, /* @__PURE__ */ React38.createElement(UitkLayoutGrid3, {
        space: "four",
        columns: {
            small: 1,
            medium: [
                "3fr",
                "1fr"
            ]
        }
    }, /* @__PURE__ */ React38.createElement(UitkLayoutGridItem3, null, searchComponent), /* @__PURE__ */ React38.createElement(UitkLayoutGridItem3, null, sortComponent)))), /* @__PURE__ */ React38.createElement(UitkLayoutGridItem3, null, reviewsContent)))), /* @__PURE__ */ React38.createElement(ExperimentVariant3, {
        bucket: 2
    }, /* @__PURE__ */ React38.createElement(UitkLayoutGridItem3, {
        colSpan: {
            small: 1,
            medium: 1,
            large: 2,
            extra_large: 2
        }
    }, /* @__PURE__ */ React38.createElement(UitkLayoutGrid3, {
        columns: 1,
        space: "six",
        alignContent: "start"
    }, /* @__PURE__ */ React38.createElement(Viewport2, null, /* @__PURE__ */ React38.createElement(ViewSmall2, null, /* @__PURE__ */ React38.createElement(UitkLayoutGrid3, {
        space: "four",
        rows: 2
    }, /* @__PURE__ */ React38.createElement(UitkLayoutGridItem3, null, searchComponent), /* @__PURE__ */ React38.createElement(UitkLayoutGridItem3, null, sortComponent))), /* @__PURE__ */ React38.createElement(ViewMedium2, null, /* @__PURE__ */ React38.createElement(UitkLayoutGrid3, {
        space: "four",
        rows: 2
    }, /* @__PURE__ */ React38.createElement(UitkLayoutGridItem3, null, searchComponent), /* @__PURE__ */ React38.createElement(UitkLayoutGridItem3, null, sortComponent))), /* @__PURE__ */ React38.createElement(ViewLarge, null, /* @__PURE__ */ React38.createElement(UitkLayoutGrid3, {
        space: "four",
        rows: 2,
        columns: 2,
        blockSize: "12vb"
    }, /* @__PURE__ */ React38.createElement(UitkLayoutGridItem3, {
        colSpan: 2
    }, searchComponent), /* @__PURE__ */ React38.createElement(UitkLayoutGridItem3, {
        colSpan: 1,
        colStart: 2
    }, /* @__PURE__ */ React38.createElement(UitkLayoutFlex12, {
        direction: "row-reverse"
    }, /* @__PURE__ */ React38.createElement(UitkLayoutFlexItem10, {
        minWidth: 302
    }, sortComponent)))))), /* @__PURE__ */ React38.createElement(UitkLayoutGridItem3, null, reviewsContent)))))));
};
PropertyFilteredReviews.displayName = "PropertyFilteredReviews";
var property_filtered_reviews_default = PropertyFilteredReviews;
// src/components/property-reviews-breakdown.tsx
var __PropertyReviewBreakdownQuery = gql38(_templateObject40(), PropertyReviewsBreakdown.fragment);
var PropertyReviewsBreakdown2 = function(param) {
    var _param_withAggregateRating = param.withAggregateRating, withAggregateRating = _param_withAggregateRating === void 0 ? false : _param_withAggregateRating, onClickLink = param.onClickLink, _param_inputs = param.inputs, propertyId = _param_inputs.propertyId, searchCriteria = _param_inputs.searchCriteria;
    var context = useBexApi9().context;
    var variables = {
        context: context,
        propertyIds: [
            propertyId
        ]
    };
    var _useQuery7 = useQuery7(__PropertyReviewBreakdownQuery, {
        variables: variables,
        errorPolicy: "all",
        fetchPolicy: "cache-first"
    }), data = _useQuery7.data, error = _useQuery7.error, loading = _useQuery7.loading;
    if (loading || error || !(data === null || data === void 0 ? void 0 : data.propertyReviewSummaries) || !data.propertyReviewSummaries.length) {
        return null;
    }
    var PropertyFilteredReviewsDialogContent = React39.memo(function() {
        return /* @__PURE__ */ React39.createElement(property_filtered_reviews_default, {
            inputs: {
                propertyId: propertyId,
                searchCriteria: searchCriteria,
                includeRecentReviews: true
            }
        });
    });
    PropertyFilteredReviewsDialogContent.displayName = "PropertyFilteredReviewsDialogContent";
    return /* @__PURE__ */ React39.createElement(PropertyFilteredReviewsDialogContext.Provider, {
        value: {
            PropertyFilteredReviewsDialogContent: PropertyFilteredReviewsDialogContent
        }
    }, /* @__PURE__ */ React39.createElement(UitkSpacing23, {
        padding: {
            blockstart: "three",
            inline: "three",
            large: {
                blockend: "three"
            }
        }
    }, /* @__PURE__ */ React39.createElement("div", null, /* @__PURE__ */ React39.createElement(PropertyReviewsBreakdown, {
        withAggregateRating: withAggregateRating,
        data: data.propertyReviewSummaries[0],
        onClickLink: onClickLink
    }))));
};
PropertyReviewsBreakdown2.displayName = "PropertyReviewsBreakdown";
// src/components/property-reviews.tsx
import React40 from "react";
import { gql as gql39, useQuery as useQuery8 } from "@apollo/client";
import { useBexApi as useBexApi10 } from "@shared-ui/bex-api-context";
import { useClickTracker as useClickTracker16 } from "@shared-ui/clickstream-analytics-context";
import { UitkSecondaryButton as UitkSecondaryButton2 } from "uitk-react-button";
import { UitkCard as UitkCard3, UitkCardContentSection as UitkCardContentSection2 } from "uitk-react-cards";
import { UitkLayoutGrid as UitkLayoutGrid4, UitkLayoutGridItem as UitkLayoutGridItem4 } from "uitk-react-layout-grid";
import { UitkSpacing as UitkSpacing24 } from "uitk-react-spacing";
var __PropertyReviewsQuery = gql39(_templateObject41(), PropertyReviewsBreakdown.fragment, PropertyReviewsListFragment);
var PropertyReviews = function(param) {
    var onClickLink = param.onClickLink, hideManagementResponse = param.hideManagementResponse, _param_inputs = param.inputs, propertyId = _param_inputs.propertyId, pagination = _param_inputs.pagination, includeRecentReviews = _param_inputs.includeRecentReviews, searchCriteria = _param_inputs.searchCriteria;
    var context = useBexApi10().context;
    var size = (pagination === null || pagination === void 0 ? void 0 : pagination.size) || DEFAULT_PAGINATION_SIZE;
    var startingIndex = (pagination === null || pagination === void 0 ? void 0 : pagination.startingIndex) || DEFAULT_STARTING_INDEX;
    var variables = {
        context: context,
        propertyId: propertyId,
        searchCriteria: {
            primary: searchCriteria.primary,
            secondary: {
                booleans: [
                    {
                        id: "includeRecentReviews",
                        value: includeRecentReviews !== null && includeRecentReviews !== void 0 ? includeRecentReviews : true
                    },
                    {
                        id: "includeRatingsOnlyReviews",
                        value: true
                    },
                    {
                        id: "overrideEmbargoForIndividualReviews",
                        value: false
                    }
                ],
                counts: [
                    {
                        id: "startIndex",
                        value: startingIndex
                    },
                    {
                        id: "size",
                        value: size
                    }
                ],
                selections: [
                    {
                        id: "sortBy",
                        value: DEFAULT_REVIEWS_SORT
                    }
                ]
            }
        }
    };
    var tracker = useClickTracker16();
    var trackedOnClickSeeAll = React40.useCallback(function() {
        if (onClickLink) {
            tracker(SEE_ALL_REVIEWS_TRACKER.rfrr, SEE_ALL_REVIEWS_TRACKER.link);
            onClickLink();
        }
    }, [
        onClickLink,
        tracker
    ]);
    var _useQuery8 = useQuery8(__PropertyReviewsQuery, {
        variables: variables,
        errorPolicy: "all",
        fetchPolicy: "cache-first"
    }), data = _useQuery8.data, error = _useQuery8.error, loading = _useQuery8.loading, fetchMore = _useQuery8.fetchMore;
    if (error || loading || !data) {
        return null;
    }
    var _data_propertyInfo_reviewInfo = data.propertyInfo.reviewInfo, summary = _data_propertyInfo_reviewInfo.summary, reviews = _data_propertyInfo_reviewInfo.reviews;
    if (!summary) {
        return null;
    }
    var paginationFetch = buildFetchMoreReviews(fetchMore, variables);
    var seeAllReviewsCallToActionLabel = summary.seeAllReviewsCallToActionLabel, accessibilityLabel = summary.accessibilityLabel;
    var PropertyFilteredReviewsDialogContent = React40.memo(function() {
        return /* @__PURE__ */ React40.createElement(property_filtered_reviews_default, {
            inputs: {
                propertyId: propertyId,
                searchCriteria: searchCriteria,
                includeRecentReviews: includeRecentReviews
            }
        });
    });
    PropertyFilteredReviewsDialogContent.displayName = "PropertyFilteredReviewsDialogContent";
    return /* @__PURE__ */ React40.createElement(PropertyFilteredReviewsDialogContext.Provider, {
        value: {
            PropertyFilteredReviewsDialogContent: PropertyFilteredReviewsDialogContent
        }
    }, /* @__PURE__ */ React40.createElement(UitkCard3, null, /* @__PURE__ */ React40.createElement(UitkCardContentSection2, null, /* @__PURE__ */ React40.createElement("h2", {
        className: "is-visually-hidden"
    }, accessibilityLabel), /* @__PURE__ */ React40.createElement(UitkLayoutGrid4, {
        columns: {
            small: 1,
            medium: 1,
            large: 3
        }
    }, /* @__PURE__ */ React40.createElement(UitkLayoutGridItem4, {
        colSpan: {
            small: 1,
            medium: 1,
            large: 1
        }
    }, /* @__PURE__ */ React40.createElement("div", null, /* @__PURE__ */ React40.createElement(UitkSpacing24, {
        padding: {
            blockstart: "three",
            inline: "three",
            large: {
                blockend: "three"
            }
        }
    }, /* @__PURE__ */ React40.createElement("div", null, /* @__PURE__ */ React40.createElement(PropertyReviewsBreakdown, {
        data: summary,
        onClickLink: trackedOnClickSeeAll,
        reviewPage: "Reviews" /* BOTTOM_PDP */ .valueOf()
    }))))), /* @__PURE__ */ React40.createElement(UitkLayoutGridItem4, {
        colSpan: {
            small: 1,
            medium: 1,
            large: 2
        }
    }, /* @__PURE__ */ React40.createElement("div", null, /* @__PURE__ */ React40.createElement("h2", {
        className: "is-visually-hidden"
    }, accessibilityLabel), /* @__PURE__ */ React40.createElement(property_reviews_list_default, {
        size: size,
        data: data.propertyInfo.reviewInfo,
        fetchMore: paginationFetch,
        hideManagementResponse: hideManagementResponse,
        showLoadMoreCTA: false,
        propertyId: propertyId,
        reviewsPage: "Reviews" /* BOTTOM_PDP */ 
    }), seeAllReviewsCallToActionLabel && onClickLink && reviews.length > 0 && /* @__PURE__ */ React40.createElement(UitkSpacing24, {
        margin: {
            block: "three"
        }
    }, /* @__PURE__ */ React40.createElement("div", null, /* @__PURE__ */ React40.createElement(UitkSecondaryButton2, {
        onClick: trackedOnClickSeeAll
    }, seeAllReviewsCallToActionLabel)))))))));
};
PropertyReviews.displayName = "PropertyReviews";
// src/components/property-room-scores.tsx
import React41 from "react";
import { gql as gql40, useQuery as useQuery9 } from "@apollo/client";
import { useBexApi as useBexApi11 } from "@shared-ui/bex-api-context";
import { UitkList, UitkListItem } from "uitk-react-list";
import { UitkLineSkeleton } from "uitk-react-skeleton";
import { UitkSpacing as UitkSpacing25 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading10, UitkText as UitkText20 } from "uitk-react-text";
var __PropertyRoomScoresQuery = gql40(_templateObject42());
var getRoomScoreFromData = function(roomId, data) {
    var propertySummaries = data.propertySummaries;
    var propertySummary = propertySummaries === null || propertySummaries === void 0 ? void 0 : propertySummaries.find(function(element) {
        return element;
    });
    var roomsScore = propertySummary === null || propertySummary === void 0 ? void 0 : propertySummary.roomsScore;
    return roomsScore === null || roomsScore === void 0 ? void 0 : roomsScore.find(function(element) {
        return element.id === roomId;
    });
};
var PropertyRoomScore = function(param) {
    var _param_inputs = param.inputs, propertyId = _param_inputs.propertyId, withTags = _param_inputs.withTags, roomId = param.roomId, _param_withinDialog = param.withinDialog, withinDialog = _param_withinDialog === void 0 ? false : _param_withinDialog;
    var context = useBexApi11().context;
    var variables = {
        context: context,
        propertyIds: [
            propertyId
        ],
        withTags: withTags
    };
    var _useQuery9 = useQuery9(__PropertyRoomScoresQuery, {
        variables: variables
    }), data = _useQuery9.data, error = _useQuery9.error, loading = _useQuery9.loading;
    if (loading) {
        return /* @__PURE__ */ React41.createElement(UitkLineSkeleton, {
            animation: false
        });
    }
    if (error || !data) {
        return null;
    }
    var roomScore = getRoomScoreFromData(roomId, data.propertyReviewAggregates);
    if (!roomScore) {
        return null;
    }
    var scoreLabel = roomScore.scoreLabel, roomRatingListTitle = roomScore.roomRatingListTitle, tags = roomScore.tags;
    if (withinDialog) {
        return /* @__PURE__ */ React41.createElement(UitkSpacing25, {
            margin: {
                blockend: "six"
            }
        }, /* @__PURE__ */ React41.createElement("div", null, /* @__PURE__ */ React41.createElement(UitkSpacing25, {
            margin: {
                blockend: "three"
            }
        }, /* @__PURE__ */ React41.createElement(UitkHeading10, {
            size: 5,
            tag: "h3"
        }, scoreLabel)), tags && tags.length > 0 && /* @__PURE__ */ React41.createElement("div", null, /* @__PURE__ */ React41.createElement(UitkHeading10, {
            size: 7,
            tag: "h4"
        }, roomRatingListTitle), /* @__PURE__ */ React41.createElement(UitkList, {
            bullet: "no-bullet"
        }, tags.map(function(tag, index) {
            return /* @__PURE__ */ React41.createElement(UitkListItem, {
                key: "tag-".concat(index)
            }, tag.label);
        })))));
    }
    return /* @__PURE__ */ React41.createElement(UitkText20, null, scoreLabel);
};
export { PropertyFilteredReviews, PropertyReviews, PropertyReviewsBreakdown2 as PropertyReviewsBreakdown, PropertyReviewsList2 as PropertyReviewsList, PropertyReviewsSnippets, PropertyReviewsSummary, PropertyReviewsSummaryLine, PropertyRoomScore }; /* istanbul ignore next -- @preserve */ 
//# sourceMappingURL=index.js.map